import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList, SimpleChanges,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  ActionSheetController,
  GestureController,
  IonSlides,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { Utils } from 'src/app/Models/Classes/utils';
import { PublicationService } from 'src/app/services/publications/publication.service';
import { InputAlertControllerService } from 'src/app/services/utils/input-alert-controller.service';
import {CommentsModalComponent} from '../comments/comments-modal/comments-modal.component';
import {ReactionssService} from '../../../services/reactions/reactions.service';
import {ActualizacionServiceService} from "../../../services/actualizacion/Actualizacion-service.service";
import Swal2 from "sweetalert2";
import  Swal from 'sweetalert2';
import { LkfilmViewBySlidesComponent } from './../../lkfilm-view-by-slides/lkfilm-view-by-slides.component';
import { RegaloModalComponent } from './../../general-design/Regalo-Modal/Regalo-Modal.component';
import {RequestService} from "../../../services/request/request.service";
import {FormServiceService} from "../../../services/publications/form-service.service";
import { PositionOptions } from '@capacitor/geolocation';
import { Message } from 'src/app/Models/Classes/Chat/message';
import { duration } from 'moment';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { SliderInformationComponent } from './../../slider-information/slider-information.component';
import { PagoVerificacionComponent } from './../../pago-verificacion/pago-verificacion.component';
import { ProfileService } from 'src/app/services/profile/profile.service';
//import {ChangeDetectorRef} from '@angular/core';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { PublicacionesColeccionComponent } from 'src/app/components/publication/create/publicaciones-coleccion/publicaciones-coleccion/publicaciones-coleccion.component';
import { InAppPurchase2,IAPProduct } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
//import { AppComponent } from 'src/app/app.component';
import { Share } from '@capacitor/share';
import {Capacitor, PluginListenerHandle} from "@capacitor/core";
import { NativeHaptics as Haptics, NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
import { CommentClass } from 'src/app/Models/Classes/Publications/Comments/comment-class';
import { CommentsService } from 'src/app/services/comments/comments.service';
import { Howl } from 'howler';
import { Meta, Title } from '@angular/platform-browser';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { SecureOperationFeedbackService } from 'src/app/services/ui/secure-operation-feedback.service';
import { RegistrationIntentService } from 'src/app/services/auth/registration-intent.service';
import { PopoverController } from '@ionic/angular';
import {PlaylistsComponent} from 'src/app/playlists/playlists.component';
//import {ContentMediaComponent} from 'src/app/components/publication/single-elements/content-media/content-media.component';
import { SeguridadComponent } from 'src/app/components/general-design/seguridad/seguridad.component';
import { SharePreviewService } from 'src/app/services/share/share-preview.service';
import { AppQualityService } from 'src/app/services/quality/app-quality.service';
import { FriendshipService } from 'src/app/services/relations/relations.service';
import { StoryViewerComponent } from 'src/app/components/stories-bar/story-viewer/story-viewer.component';
import { addIcons } from 'ionicons';
import {
  arrowRedo, bookmark, bookmarkOutline, chatboxEllipsesOutline, disc,
  eyeOutline, giftOutline, heart, heartHalfOutline, hourglassOutline, musicalNote
} from 'ionicons/icons';

// The draft preview can be the first publication rail mounted in a session.
// Register its glyphs locally so the first frame does not wait for SVG fetches.
addIcons({
  'arrow-redo': arrowRedo,
  bookmark,
  'bookmark-outline': bookmarkOutline,
  'chatbox-ellipses-outline': chatboxEllipsesOutline,
  disc,
  'eye-outline': eyeOutline,
  'gift-outline': giftOutline,
  heart,
  'heart-half-outline': heartHalfOutline,
  'hourglass-outline': hourglassOutline,
  'musical-note': musicalNote,
});

@Component({
	selector: 'app-publication-media-template',
	templateUrl: './publication-media-template.component.html',
	styleUrls: ['./publication-media-template.component.scss'],
})
export class PublicationMediaTemplateComponent implements AfterViewInit, OnChanges, OnDestroy {
  private nativePublicationControlListener?: PluginListenerHandle;
  private readonly videoJsonLdScriptId = 'lk-publication-video-jsonld';
  isFetchingPublications;
  showMoreTimeout;
  public fetchBannerVisible = false;
  public fetchBannerClosing = false;
  public reactionPending: Record<string, boolean> = {};
  public feedFeedbackPending: Record<string, boolean> = {};
  private authorStoriesByPublicationId: Record<string, PublicationClass[]> = {};
  private authorStoriesLoading = new Set<string>();

  private async lightHaptic(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await Haptics.impact({ style: 'LIGHT' });
    } catch {}
  }
  public fetchBannerTitle = 'Alien intelligence craft';
  public fetchBannerMessage = 'Retrieving the next publications. Stay on this signal.';
  window_width: string = '100'; // Example: Set this dynamically as needed
  @Input() media_index: any=0;
  timeoutId;
  SlideInteraction:boolean=true;
  @ViewChild('slides', { static: true }) slides: IonSlides;
	public newComment: CommentClass;
  public HubbleExpired: boolean = false;
  pr:any;
  public msg:string="Leyendo..";
  productId2: string = '1618';
  @Input() publications: any;
  @Input() previewMode: boolean = false;
  cached_publications;
  @Input() valueSelect: string;
  @Input() externalPagination: boolean = false;
  @Input() externalPaginationLoading: boolean = false;
  @Input() externalPaginationHasMore: boolean = true;
  @Input() feedFeedbackEnabled: boolean = false;
  @Input() preloadNextVideo: boolean = false;
  @Input() actual_publication_section: string;
  @Input() profile_id?: number;
  NextSlide: any;
  @Input() discardInteractions: boolean = false;
	@Output() publicationDeleted = new EventEmitter<boolean>();
  @Output() requestNextPage = new EventEmitter<void>();
  @Output() publicationSwipe = new EventEmitter<void>();
  @Output() publicationNotInterested = new EventEmitter<number>();
  @Input() initial_index = 0;
  public publication_position = 0;

  get isFeexMediaTemplate(): boolean {
    const publications = Array.isArray(this.publications) ? this.publications : [this.publications];
    return publications.some((publication: any) =>
      String(publication?.publication_type || publication?.type || '').toLowerCase().includes('feex')
    );
  }
slideOpts: any = {
  direction: 'vertical',
  initialSlide: 0,
  // TikTok-style feed tuning: begin tracking quickly and commit a deliberate
  // vertical drag after roughly one fifth of a screen, instead of Swiper's
  // default half-screen long-swipe requirement.
  threshold: 4,
  touchRatio: 1.2,
  touchAngle: 35,
  longSwipesMs: 400,
  longSwipesRatio: 0.2,
  shortSwipes: true,
  resistanceRatio: 0.72,
  speed: 420,
  loop: false,                // safer on iOS (no DOM cloning)
//  effect: 'slide',            // keep it basic
  //threshold: 10,              // need a real swipe to start
  //resistanceRatio: 0.65,      // less rubber-banding
 // preventInteractionOnTransition: true, // ignore swipes until animation ends
 // touchReleaseOnEdges: true,
//  observer: true,
  //observeParents: true,
  // If your IonSlides/Swiper version supports it, this is the most stable:
  // cssMode: true,           // native scroll; comment out if you get an unknown option error
  //preloadImages: false,
  //lazy: true,                 // only load what’s needed
};
  lanzamiento
  numero=10
  mostrar:boolean=false
  activeSlideIndex: number = 0;
  private wheelLock = false;
  private removeMediaPlaybackGuard: (() => void) | null = null;
  private activePlayableMedia: HTMLMediaElement | null = null;
  private preloadedVideo: HTMLVideoElement | null = null;
  private removeWheelListener: (() => void) | null = null;
  private readonly resizeHandler = this.onResize.bind(this);
  private swipeOnboardingOverlayEl: HTMLElement | null = null;
  private swipeOnboardingStyleEl: HTMLStyleElement | null = null;
  private swipeOnboardingTimeout: any;
  private swipeOnboardingCloseTimeout: any;
  private fetchBannerEl: HTMLElement | null = null;
  private fetchBannerTitleEl: HTMLElement | null = null;
  private fetchBannerMessageEl: HTMLElement | null = null;
  private fetchBannerHideTimeout: any;
  private fetchBannerRemoveTimeout: any;
  private awaitingExternalPage = false;
  private lastKnownPublicationsLength = 0;
  private profilePaginationPage = 1;
  private seenPublicationIds = new Set<number>();
  private incrementedViewPublicationIds = new Set<number>();
  private seenRequestInFlight = false;
  private pendingSeenPublicationIds = new Set<number>();
  private viewVisibilityObserver: IntersectionObserver | null = null;
  private viewDwellTimeout: any;
  private viewCandidateId: number | null = null;
  private mediaPlaybackFrameId: number | null = null;
  private mediaPlaybackFrameResolve: (() => void) | null = null;
  private actionRailPositionFrameId: number | null = null;
  private actionRailMutationObserver?: MutationObserver;
  private actionRailResizeObserver?: ResizeObserver;
  private observedActionScrubber: HTMLElement | null = null;
  private lastActionGeometry = '';
  private readonly scrubberGeometryChangedListener = () => this.scheduleActionRailPositionSync();
  private nextPublicationCursor: string | null = null;
  private cursorHasMore = true;
	private cursorContextKey: string | null = null;
  private initialViewTimeout: any;
	private slideInteractionStartedAt?: number;
	constructor(
		//public actionSheetController: ActionSheetController,
		private publicationService: PublicationService,
		private friendshipService: FriendshipService,
		private navCtrl: NavController,
		private utils: Utils,
		private inputAlertController: InputAlertControllerService,
		private reactionService: ReactionssService,
    private modalController: ModalController,
    private actualizacionservice: ActualizacionServiceService,
    private formService: FormServiceService,
    private request: RequestService,
    //private toastController: ToastController,
    private faio:FingerprintAIO,
    private walletService: WalletServiceService,
    private profile:ProfileService,
    //private changeDetectorRef: ChangeDetectorRef,
    private clipboard: Clipboard,
    private store: InAppPurchase2, 
   // public app :  AppComponent,
    private ActionSheetController: ActionSheetController,
    private toastController: ToastController,
    private commentService: CommentsService,
    private metaService: Meta, 
    private titleService: Title,
    private popoverCtrl:PopoverController,
    private renderer: Renderer2,
    private socialNotifications: SocialInteractionNotificationService,
    private secureFeedback: SecureOperationFeedbackService,
    private registrationIntent: RegistrationIntentService,
    private sharePreviewService: SharePreviewService,
    private elementRef: ElementRef<HTMLElement>,
	private appQuality: AppQualityService,

   // private web: WebviewComponent 
    ) { 
      window.addEventListener('resize', this.resizeHandler);
	  this.appQuality.beginSurfaceLoad('publication-media');
	}

  public async markNotInterested(pub: any): Promise<void> {
    const publicationId = Number(pub?.id);
    if (!this.feedFeedbackEnabled || !Number.isSafeInteger(publicationId) || publicationId <= 0
      || this.feedFeedbackPending[publicationId]) return;
    if (!await this.registrationIntent.requireAccount('not-interested')) return;

    this.feedFeedbackPending[publicationId] = true;
    try {
      await this.publicationService.markPublicationNotInterested(publicationId);
      const removedIndex = this.publications.findIndex((publication: any) => Number(publication?.id) === publicationId);
      this.publicationNotInterested.emit(publicationId);
      setTimeout(async () => {
        if (!this.slides || !this.publications?.length) return;
        await this.slides.update();
        this.activeSlideIndex = Math.min(Math.max(removedIndex, 0), this.publications.length - 1);
        await this.slides.slideTo(this.activeSlideIndex, 0, false);
        await this.enforceActiveSlideMediaPlayback(this.activeSlideIndex);
      }, 0);
    } catch {
      const toast = await this.toastController.create({
        message: 'No se pudo guardar tu preferencia. Inténtalo de nuevo.',
        duration: 2500,
      });
      await toast.present();
    } finally {
      delete this.feedFeedbackPending[publicationId];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.preloadNextVideo) {
      this.prepareNextVideo(this.nextVideoToPreload(this.activeSlideIndex));
    }
    
    console.log('Publication media template Changes detected at ', changes);
    if (changes !== undefined) {
      if ('valueSelect' in changes || 'profile_id' in changes || 'actual_publication_section' in changes) {
        this.resetCursorPagination();
        // Profile pages keep their original numbered endpoint. Reset its local
        // page whenever the profile or section changes so Popular, Reciente,
        // Proliferado, media, and other profile-backed lists cannot inherit a
        // page number from the previously opened profile context.
        this.profilePaginationPage = 1;
      }
      
      if('publications' in changes) {
        const nextPublications = changes.publications.currentValue || [];
        const previousLength = this.lastKnownPublicationsLength;
        const previousVisible = Array.isArray(this.publications) ? [...this.publications] : [];
        const anchorPublication = previousVisible[this.activeSlideIndex]
          || previousVisible[previousVisible.length - 1];
        const receivedExternalPage = this.externalPagination
          && this.awaitingExternalPage
          && nextPublications.length > previousLength;
        this.lastKnownPublicationsLength = nextPublications.length;
        this.publications = receivedExternalPage
          ? this.buildExternalPaginationWindow(nextPublications, previousLength)
          : (this.externalPagination ? this.buildVisibleWindow(nextPublications) : nextPublications);
        if (this.externalPagination) {
          this.cached_publications = nextPublications;
          this.formService.publications = this.publications;
          this.handleExternalPaginationUpdate(previousLength, nextPublications.length, anchorPublication);
        }
        if (!this.previewMode) this.syncSeoMetadata();

        // Defensive: tell IonSlides to re-measure after the publications array changed.
        // This helps prevent index corruption (e.g. "jumps to last post when returning to first")
        // that was observed specifically when viewing profile posts from home/profile.
        Promise.resolve().then(() => {
          if (this.slides) {
            void this.slides.update().then(() => this.enforceActiveSlideMediaPlayback());
          }
        });
        

      }
      if (this.externalPagination && 'externalPaginationLoading' in changes) {
        this.handleExternalPaginationStatusChange();
      }
      if (changes['media_index'] && changes['media_index'].currentValue !== undefined ) {
        if (changes['media_index'].currentValue > changes['media_index'].previousValue) {
          this.slides.slideNext();
        } else {
          if(this.slides){
            this.slides.slidePrev();
          }
      
        }
      }
    }


  }
  calculateSlidesPerView() {
		// A feed post owns the available horizontal surface on every breakpoint.
		// The old desktop 81vw cap left a visible gutter around the media.
    this.window_width = '100';

  }
  onResize(event: Event) {
    this.formService.mostrar=false;
    this.calculateSlidesPerView();
    this.scheduleActionRailPositionSync();
  }

  /**
   * The scrubber belongs to app-content-media and can move after the parent
   * template has rendered (safe areas, native footer, pause state).  Anchor
   * this template's rail to its actual top edge, rather than guessing in vh.
   */
  private bindActionRailPositioning(): void {
    const host = this.elementRef.nativeElement;
    host.addEventListener('publicationScrubberGeometryChanged', this.scrubberGeometryChangedListener);
    if (typeof MutationObserver !== 'undefined') {
      this.actionRailMutationObserver = new MutationObserver(() => this.scheduleActionRailPositionSync());
      this.actionRailMutationObserver.observe(host, { childList: true, subtree: true });
    }
    if (typeof ResizeObserver !== 'undefined') {
      this.actionRailResizeObserver = new ResizeObserver(() => this.scheduleActionRailPositionSync());
      this.actionRailResizeObserver.observe(host);
    }
  }

  private scheduleActionRailPositionSync(): void {
    if (this.actionRailPositionFrameId !== null) return;
    this.actionRailPositionFrameId = requestAnimationFrame(() => {
      this.actionRailPositionFrameId = null;
      this.syncActionRailPosition();
    });
  }

  private syncActionRailPosition(): void {
    if (document.body.classList.contains('laniakea-landscape-video-open')) return;
    const host = this.elementRef.nativeElement;
    const slides = host.querySelectorAll<HTMLElement>('ion-slide');
    const activeSlide = host.querySelector<HTMLElement>('.swiper-slide-active')
      || slides[this.activeSlideIndex];
    const railWrapper = activeSlide?.querySelector<HTMLElement>('.reactions-wrapper');
    const rail = railWrapper?.querySelector<HTMLElement>('.Reactions');
    const scrubber = activeSlide?.querySelector<HTMLElement>('.video-scrubber-shell');

    if (!railWrapper || !rail) return;
    // Re-observing an unchanged target generates another initial notification.
    // Keep the subscription stable so layout can settle between measurements.
    if (this.observedActionScrubber !== (scrubber || null)) {
      if (this.observedActionScrubber) this.actionRailResizeObserver?.unobserve(this.observedActionScrubber);
      this.observedActionScrubber = scrubber || null;
      if (scrubber) this.actionRailResizeObserver?.observe(scrubber);
      this.lastActionGeometry = '';
    }
    if (!scrubber) {
      const key = `${this.activeSlideIndex}:hidden`;
      if (this.lastActionGeometry !== key) {
        this.lastActionGeometry = key;
        railWrapper.style.removeProperty('--publication-actions-rail-bottom');
        rail.style.removeProperty('bottom');
        activeSlide?.style.removeProperty('--publication-information-card-top');
        void this.syncNativeInformationForPublication(this.publications?.[this.activeSlideIndex], { scrubberVisible: false });
      }
      return;
    }

    const wrapperBounds = railWrapper.getBoundingClientRect();
    const scrubberBounds = scrubber.getBoundingClientRect();
    if (scrubberBounds.width <= 0 || scrubberBounds.height <= 0) return;
    // The rail's bottom edge is 12px above the *top* of the rendered scrubber.
    // No margin is used and the X axis is untouched.
    const bottom = Math.max(0, Math.round(wrapperBounds.bottom - scrubberBounds.top + 12));
    const bottomValue = `${bottom}px`;
    if (railWrapper.style.getPropertyValue('--publication-actions-rail-bottom') !== bottomValue) {
      railWrapper.style.setProperty('--publication-actions-rail-bottom', bottomValue);
    }
    if (rail.style.bottom !== bottomValue) rail.style.bottom = bottomValue;

    const informationCard = activeSlide.querySelector<HTMLElement>('app-information .information-card');
    const slideBounds = activeSlide.getBoundingClientRect();
    const informationHeight = informationCard?.getBoundingClientRect().height ?? 0;
    if (informationHeight > 0) {
      const top = Math.max(
        informationHeight / 2,
        scrubberBounds.top - slideBounds.top - informationHeight / 2 - 12,
      );
      const topValue = `${Math.round(top)}px`;
      if (activeSlide.style.getPropertyValue('--publication-information-card-top') !== topValue) {
        activeSlide.style.setProperty('--publication-information-card-top', topValue);
      }
    }

    const geometryKey = `${this.activeSlideIndex}:${scrubberBounds.top}:${window.innerHeight}`;
    if (this.lastActionGeometry === geometryKey) return;
    this.lastActionGeometry = geometryKey;
    void this.syncNativeInformationForPublication(this.publications?.[this.activeSlideIndex], {
      scrubberVisible: true,
      scrubberTop: scrubberBounds.top,
      webViewHeight: window.innerHeight,
    });
  }
  ionViewDidLeave() {
    console.log('ion-slides are hidden (background).');
    this.formService.muteAllMedia();
    // Perform actions when slides are in the background
  }

  toggleActiveVideoMute(event?: Event): void {
    event?.stopPropagation();
    const activeSlide = document.querySelector('.publication-media-template-simple .swiper-slide-active')
      || document.querySelectorAll('.publication-media-template-simple ion-slide')[this.activeSlideIndex];
    const video = activeSlide?.querySelector('video') as HTMLVideoElement | null;
    if (!video) return;
    video.muted = !video.muted;
    video.volume = video.muted ? 0 : 1;
    if (!video.muted && video.paused) void video.play().catch(() => undefined);
  }

  private async setNativePublicationInformationVisible(visible: boolean): Promise<void> {
    if (Capacitor.getPlatform() !== 'ios') return;
    if (visible && !this.isNativePublicationSurfaceEligible()) return;
    if (visible) {
      await NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: false }).catch(() => ({ available: false }));
      await NativeLiquidGlass.setRegion({ region: 'publication-info', visible: true, suppressed: false }).catch(() => ({ available: false }));
    } else {
      await NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: true }).catch(() => ({ available: false }));
      await NativeLiquidGlass.setRegion({ region: 'publication-info', visible: false, suppressed: true }).catch(() => ({ available: false }));
    }
    document.body.classList.toggle('native-publication-info', visible);
    window.dispatchEvent(new CustomEvent('nativePublicationInfoVisibility', { detail: { visible } }));
  }

  click_on_share(publication: any) {
    const publicationId = publication.id;
    const url = this.sharePreviewService.publication(publicationId);
  
    if(Capacitor.getPlatform() !== 'web'){
    // Copy the URL to clipboard
    this.clipboard.copy(url)
      .then(() => {
        console.log('URL copied to clipboard:', url);
        Swal.fire({
          title: 'URL copied!',
          text: 'El URL ha sido copiado en el portapapeles.',
          icon: 'success',
          timer: 2000, // Show the alert for 2 seconds
          timerProgressBar: true,
          toast: true,
          position: 'top-end',
          showConfirmButton: false
        });
      })
      .catch((error) => {
        console.error('Error copiando el URL en el portapapeles:', error);
        Swal.fire({
          title: 'Error',
          text: 'Error copiando el URL en el portapapeles.',
          icon: 'error',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000 // Show the alert for 2 seconds
        });
      });
    }else{
      navigator.clipboard.writeText(url).then(() => {
        Swal.fire({
          title: 'Respuesta copiada!',
          text: 'La respuesta ha sido copiado en el portapapeles.',
          icon: 'success',
          timer: 2000, // Show the alert for 2 seconds
          timerProgressBar: true,
          toast: true,
          position: 'top-end',
          showConfirmButton: false
          });
      }).catch((error) => {
        //console.error(error);
      });
    }
  }

  ngOnInit() {
    if (this.previewMode) {
      // The description composer is an exact final preview: information and
      // counters must remain visible without changing the saved viewer choice.
      this.formService.showMoreHidden = false;
      this.calculateSlidesPerView();
      this.cached_publications = [...(this.publications || [])];
      this.lastKnownPublicationsLength = this.publications?.length || 0;
      this.publication_position = 0;
      return;
    }
    // Start hidden until the user explicitly chooses a different state. Keep
    // that choice in FormService for subsequent slides/viewer instances.
    if (!this.formService.showMorePreferenceChanged) {
      this.formService.showMoreHidden = true;
    }
    if (Capacitor.getPlatform() === 'ios') {
      NativeLiquidGlass.addListener('publicationControlAction', ({ action }) => {
        if (action === 'previousPublication') this.backPub();
        if (action === 'nextPublication') this.nextPub();
        if (action === 'toggleInfo') this.setShowMoreHidden(!this.formService.showMoreHidden);
        if (action === 'details' || action === 'planet' || action === 'buy') {
          window.dispatchEvent(new CustomEvent('nativePublicationInfoAction', { detail: { action } }));
        }
      }).then(listener => this.nativePublicationControlListener = listener).catch(() => undefined);
      document.body.classList.remove('native-publication-controls');
      NativeLiquidGlass.setRegion({ region: 'publication-slide-nav', visible: false }).catch(() => undefined);
    }
    this.tryLaunchGlobalSwipeOnboarding();
    this.calculateSlidesPerView();
   // Keep the complete pagination cache independent from the rendered window.
   // Sharing this array reference caused appended pages to be inserted twice and
   // eventually made the original first profile post unreachable.
   this.cached_publications = [...(this.publications || [])];
   this.lastKnownPublicationsLength = this.publications?.length || 0;
    this.publication_position = 0;
    this.formService.lkpublication.index_close = 0;
    this.profile.getProfileInfo().then((result)=>{
      this.pr = JSON.parse(result);
      console.log("profile", this.pr);
      });
      //this.slides.ionSlidesDidLoad.subscribe(() => {
        //this.autoplayActiveSlide();
      //});
    this.syncSeoMetadata();
	}


/*
  autoplayActiveSlide() {
    this.slides.getActiveIndex().then((index: number) => {
      this.activeSlideIndex = index;
      console.log('Template Active slide index:', this.activeSlideIndex);
    });
  }
  */
  
  
  async nextPub() {
    this.formService.mostrar = false; 
    if(this.SlideInteraction){
this.SlideInteraction=false;
this.timeoutId = setTimeout(() => {
  this.SlideInteraction=true;
}, 3000);
console.log('next');
const currentIndex = await this.slides.getActiveIndex();
const totalSlides = await this.slides.length();

if (currentIndex < totalSlides - 1) {
  this.slides.slideNext();
} else {
  console.log('No more pub slides available');
}
    }
   
  }
  backPub(){
    this.slides.slidePrev(); // Method to move to the next slide
  }
  
  
  
  private async incrementActivePublicationView(publication: any): Promise<void> {
    if (this.previewMode) return;

    const publicationId = Number(publication?.id);
    if (!Number.isInteger(publicationId) || publicationId <= 0 || this.incrementedViewPublicationIds.has(publicationId)) {
      return;
    }

    // Reserve the ID before awaiting so rapid slide events cannot duplicate it.
    this.incrementedViewPublicationIds.add(publicationId);
    try {
      await this.request.createRequestPost('incrementViews', { id: publicationId });
    } catch (error) {
      this.incrementedViewPublicationIds.delete(publicationId);
      console.error('[Publications] Unable to increment active publication view', error);
    }
  }
  
  
  private tryLaunchGlobalSwipeOnboarding() {
    if (
      this.formService.launchPublicationMediaTemplateSwipeOnboardingShown ||
      this.formService.globalSwipeOnboardingShown
    ) {
      return;
    }

    this.formService.launchPublicationMediaTemplateSwipeOnboardingShown = true;
    this.launchGlobalSwipeOnboarding();
  }

  private async launchGlobalSwipeOnboarding() {
    if (typeof document === 'undefined') {
      return;
    }

    if (this.formService.globalSwipeOnboardingShown) {
      return;
    }

    this.formService.globalSwipeOnboardingShown = true;
    const shouldShowOnboarding = await this.utils.consumeOneTimeFlag('global_swipe_onboarding_shown');
    if (!shouldShowOnboarding) {
      return;
    }

    this.removeGlobalSwipeOnboarding(true);

    const style = document.createElement('style');
    style.id = 'lk-global-swipe-onboarding-style';
    style.textContent = `
      .lk-global-swipe-onboarding {
        position: fixed;
        inset: 0;
        z-index: 2147483646;
        background: #f6f6f6;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        animation: lkPagePeek 1.8s ease-in-out infinite;
        transform: translateY(0);
        will-change: transform;
      }

      .lk-global-swipe-onboarding.lk-exit {
        animation: lkExitToTop 420ms ease-in forwards !important;
      }

      .lk-global-swipe-onboarding__title {
        position: absolute;
        top: 14vh;
        margin: 0;
        text-align: center;
        font-size: clamp(34px, 7vw, 46px);
        line-height: 1.05;
        font-weight: 800;
        color: #000;
      }

      .lk-global-swipe-onboarding__title span { display: block; }

      .lk-global-swipe-onboarding__card {
        width: 148px;
        height: 248px;
        border-radius: 28px;
        background: #bdbdbd;
        box-shadow: inset 0 3px 0 rgba(255,255,255,0.35);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .lk-global-swipe-onboarding__play {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-left: 22px solid #e7e7e7;
        margin-left: 8px;
      }

      .lk-global-swipe-onboarding__pill {
        position: absolute;
        bottom: 12px;
        width: 26px;
        height: 3px;
        border-radius: 999px;
        background: #d9d9d9;
      }

      .lk-global-swipe-onboarding__hand {
        position: absolute;
        right: -52px;
        top: 112px;
        width: 84px;
        height: 84px;
        border-radius: 48px;
        border: 2px solid #222;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: lkSwipeHand 1s ease-in-out infinite;
      }

      .lk-global-swipe-onboarding__hand ion-icon {
        font-size: 40px;
        color: #222;
      }

      .lk-global-swipe-onboarding__chevrons {
        position: absolute;
        bottom: 15vh;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .lk-global-swipe-onboarding__chevrons span {
        width: 10px;
        height: 10px;
        border-top: 2px solid #333;
        border-left: 2px solid #333;
        transform: rotate(45deg);
        opacity: 0;
        animation: lkChevronPulse 1s ease-in-out infinite;
      }

      .lk-global-swipe-onboarding__chevrons span:nth-child(2) { animation-delay: 0.15s; }
      .lk-global-swipe-onboarding__chevrons span:nth-child(3) { animation-delay: 0.3s; }

      @keyframes lkSwipeHand {
        0%,100% { transform: translate(0,0) scale(1); }
        35% { transform: translate(-8px,-16px) scale(0.98); }
      }

      @keyframes lkChevronPulse {
        0% { opacity: 0; transform: translateY(6px) rotate(45deg); }
        45% { opacity: 1; transform: translateY(-4px) rotate(45deg); }
        100% { opacity: 0; transform: translateY(-10px) rotate(45deg); }
      }

      @keyframes lkExitToTop {
        0% { transform: translateY(0); opacity: 1; }
        100% { transform: translateY(-100%); opacity: 1; }
      }

      @keyframes lkPagePeek {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-32px); }
      }
    `;

    const overlay = document.createElement('div');
    overlay.className = 'lk-global-swipe-onboarding';
    overlay.innerHTML = `
      <h2 class="lk-global-swipe-onboarding__title">Swipe up to start<span>watching</span></h2>
      <div class="lk-global-swipe-onboarding__card">
        <div class="lk-global-swipe-onboarding__play"></div>
        <div class="lk-global-swipe-onboarding__pill"></div>
        <div class="lk-global-swipe-onboarding__hand"><ion-icon name="hand-left-outline"></ion-icon></div>
      </div>
      <div class="lk-global-swipe-onboarding__chevrons" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
    `;

    document.head.appendChild(style);
    document.body.appendChild(overlay);

    this.swipeOnboardingStyleEl = style;
    this.swipeOnboardingOverlayEl = overlay;

    this.swipeOnboardingTimeout = setTimeout(() => {
      this.removeGlobalSwipeOnboarding();
    }, 5300);
  }

  private removeGlobalSwipeOnboarding(immediate = false) {
    if (this.swipeOnboardingTimeout) {
      clearTimeout(this.swipeOnboardingTimeout);
      this.swipeOnboardingTimeout = null;
    }

    if (this.swipeOnboardingCloseTimeout) {
      clearTimeout(this.swipeOnboardingCloseTimeout);
      this.swipeOnboardingCloseTimeout = null;
    }

    const overlay = this.swipeOnboardingOverlayEl;

    if (overlay && !immediate && !overlay.classList.contains('lk-exit')) {
      overlay.classList.add('lk-exit');
      this.swipeOnboardingCloseTimeout = setTimeout(() => {
        this.removeGlobalSwipeOnboarding(true);
      }, 420);
      return;
    }

    if (overlay?.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    this.swipeOnboardingOverlayEl = null;

    if (this.swipeOnboardingStyleEl?.parentNode) {
      this.swipeOnboardingStyleEl.parentNode.removeChild(this.swipeOnboardingStyleEl);
    }
    this.swipeOnboardingStyleEl = null;
  }

  async ngAfterViewInit() {
    await this.slides.slideTo(this.initial_index, 0, false);
    const initialActiveIndex = await this.slides.getActiveIndex();
    this.activeSlideIndex = initialActiveIndex;
    this.formService.publication_template_index=this.initial_index;
    // A template can be created immediately after a routed workspace (such as
    // Mycelium) deliberately suppressed publication chrome. Claim ownership
    // only once this concrete media surface is visible, then publish its first
    // slide. This makes the native info/toggle control deterministic instead
    // of depending on the previous route's asynchronous teardown.
    await this.activateNativePublicationChromeForVisibleSurface();
    await this.syncNativeInformationForPublication(this.publications?.[initialActiveIndex]);
    this.loadAuthorStoriesForPublication(this.publications?.[initialActiveIndex]);
    this.bindActiveSlideMediaGuard();
    this.bindActionRailPositioning();
    this.scheduleActionRailPositionSync();
    await this.enforceActiveSlideMediaPlayback(initialActiveIndex);
    await this.bindDesktopWheelNavigation();
	this.appQuality.markFeedFirstContent('publication-media', 'existing');
    this.initialViewTimeout = setTimeout(() => {
      this.initialViewTimeout = null;
      this.markActivePublicationAsSeen();
    }, 500);
  }

  @HostListener('document:click')
  @HostListener('document:touchstart')
  onPageInteraction(): void {
    this.removeGlobalSwipeOnboarding();
  }

  ngOnDestroy(): void {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    if (this.showMoreTimeout) clearTimeout(this.showMoreTimeout);
    if (this.initialViewTimeout) clearTimeout(this.initialViewTimeout);
    if (this.lanzamiento) clearInterval(this.lanzamiento);
    this.timeoutId = null;
    this.showMoreTimeout = null;
    this.initialViewTimeout = null;
    this.lanzamiento = null;
    this.nativePublicationControlListener?.remove();
    document.body.classList.remove('native-publication-controls');
    document.body.classList.remove('native-publication-info');
    if (Capacitor.getPlatform() === 'ios') {
      NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: true }).catch(() => undefined);
      NativeLiquidGlass.setRegion({ region: 'publication-info', visible: false, suppressed: true }).catch(() => undefined);
      NativeLiquidGlass.setRegion({ region: 'publication-slide-nav', visible: false }).catch(() => undefined);
    }
    this.clearWheelListener();
    this.removeMediaPlaybackGuard?.();
    this.removeMediaPlaybackGuard = null;
    this.cancelQualifiedViewTracking();
    this.cancelPendingMediaFrame();
    if (this.actionRailPositionFrameId !== null) cancelAnimationFrame(this.actionRailPositionFrameId);
    this.actionRailMutationObserver?.disconnect();
    this.actionRailResizeObserver?.disconnect();
    this.observedActionScrubber = null;
    this.elementRef.nativeElement.removeEventListener('publicationScrubberGeometryChanged', this.scrubberGeometryChangedListener);
    this.releaseAllPublicationMedia();
    this.activePlayableMedia = null;
    this.removeFetchBannerDom(true);
    this.removeGlobalSwipeOnboarding();
    this.removeVideoJsonLd();
    window.removeEventListener('resize', this.resizeHandler);
  }

  private async markActivePublicationAsSeen() {
    if (!this.slides) {
      return;
    }

    const currentIndex = await this.slides.getActiveIndex();
    this.activeSlideIndex = currentIndex;
    this.scheduleQualifiedActiveView(currentIndex);
  }

  private scheduleQualifiedActiveView(index: number): void {
    this.cancelQualifiedViewTracking();
    if (this.previewMode) return;

    const publication = this.publications?.[index];
    const publicationId = Number(publication?.id);
    const activeSlide = this.getActivePublicationSlide(index);
    if (!activeSlide || !Number.isInteger(publicationId) || publicationId <= 0) return;

    this.viewCandidateId = publicationId;
    const beginDwell = () => {
      if (this.viewDwellTimeout || this.viewCandidateId !== publicationId) return;
      this.viewDwellTimeout = setTimeout(async () => {
        this.viewDwellTimeout = null;
        if (this.viewCandidateId !== publicationId || !this.slides) return;
        const currentIndex = await this.slides.getActiveIndex().catch(() => -1);
        const currentPublication = this.publications?.[currentIndex];
        if (Number(currentPublication?.id) !== publicationId) return;
        this.markPublicationAsSeen(currentPublication);
        await this.incrementActivePublicationView(currentPublication);
      }, 1000);
    };
    const cancelDwell = () => {
      if (this.viewDwellTimeout) clearTimeout(this.viewDwellTimeout);
      this.viewDwellTimeout = null;
    };

    if (typeof IntersectionObserver === 'undefined') {
      if (this.visibleRatio(activeSlide) >= 0.6) beginDwell();
      return;
    }

    const root = ((this.slides as any)?.el as HTMLElement | undefined) || null;
    this.viewVisibilityObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry?.isIntersecting && entry.intersectionRatio >= 0.6) beginDwell();
      else cancelDwell();
    }, { root, threshold: [0, 0.6, 1] });
    this.viewVisibilityObserver.observe(activeSlide);
  }

  private visibleRatio(element: HTMLElement): number {
    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return 0;
    const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    return (visibleWidth * visibleHeight) / (rect.width * rect.height);
  }

  private cancelQualifiedViewTracking(): void {
    this.viewVisibilityObserver?.disconnect();
    this.viewVisibilityObserver = null;
    if (this.viewDwellTimeout) clearTimeout(this.viewDwellTimeout);
    this.viewDwellTimeout = null;
    this.viewCandidateId = null;
  }

  private markPublicationAsSeen(publication: any) {
    const publicationId = Number(publication?.id);

    if (!this.formService.profile || !Number.isInteger(publicationId) || publicationId <= 0 || this.seenPublicationIds.has(publicationId)) {
      return;
    }

    this.seenPublicationIds.add(publicationId);
    this.pendingSeenPublicationIds.add(publicationId);
    this.flushSeenPublications();
  }

  private async flushSeenPublications() {
    if (this.seenRequestInFlight || this.pendingSeenPublicationIds.size < 1) {
      return;
    }

    this.seenRequestInFlight = true;
    const publication_ids = Array.from(this.pendingSeenPublicationIds);
    this.pendingSeenPublicationIds.clear();

    try {
      await this.request.createRequestPost('publications/seen', { publication_ids });
    } catch (error) {
      publication_ids.forEach((publicationId) => {
        this.pendingSeenPublicationIds.add(publicationId);
        this.seenPublicationIds.delete(publicationId);
      });
      console.error('[Publications] Unable to mark active publication as seen', error);
    } finally {
      this.seenRequestInFlight = false;
      if (this.pendingSeenPublicationIds.size > 0) {
        this.flushSeenPublications();
      }
    }
  }

  private syncSeoMetadata(): void {
    const publication = this.getPrimaryPublication();
    if (!publication) {
      return;
    }

    const title = this.getPublicationTitle(publication);
    const description = this.getPublicationDescription(publication);
    const canonicalUrl = this.getPublicationCanonicalUrl();
    const mediaUrl = this.getPublicationMediaUrl(publication);
    const thumbnailUrl = this.getPublicationThumbnailUrl(publication);
    const isVideo = this.isVideoPublication(publication, mediaUrl);
    const heroImage = thumbnailUrl || mediaUrl || this.getDefaultSeoImage();

    document.title = title;
    this.metaService.updateTag({ name: 'description', content: description });
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:url', content: canonicalUrl });
    this.metaService.updateTag({ property: 'og:type', content: isVideo ? 'video.other' : 'article' });
    this.metaService.updateTag({ property: 'og:image', content: heroImage });
    this.metaService.updateTag({ property: 'og:image:alt', content: title });
    this.metaService.updateTag({ name: 'twitter:title', content: title });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaService.updateTag({ name: 'twitter:image', content: heroImage });
    this.metaService.updateTag({ name: 'twitter:image:alt', content: title });

    if (isVideo && mediaUrl) {
      this.metaService.updateTag({ property: 'og:video', content: mediaUrl });
      this.metaService.updateTag({ property: 'og:video:secure_url', content: mediaUrl });
      this.metaService.updateTag({ property: 'og:video:type', content: this.getVideoMimeType(mediaUrl) });
    }

    this.updateCanonical(canonicalUrl);
    this.updateVideoJsonLd(publication, canonicalUrl, mediaUrl, heroImage, description, title, isVideo);
  }

  private getPrimaryPublication(): any {
    return Array.isArray(this.publications) ? this.publications[0] : this.publications;
  }

  private getPublicationTitle(publication: any): string {
    const title = (publication?.title || publication?.container?.title || '').toString().trim();
    return title || 'Laniakea video post';
  }

  private getPublicationDescription(publication: any): string {
    const description = (publication?.description || publication?.container?.description || '').toString().trim();
    return description || 'A featured publication from Laniakea.';
  }

  private getPublicationCanonicalUrl(): string {
    const currentUrl = new URL(window.location.href);
    const publicationId = currentUrl.searchParams.get('p');

    if (currentUrl.pathname.includes('/home/ecosystem-page') && publicationId) {
      return `${currentUrl.origin}/home/ecosystem-page/${encodeURIComponent(publicationId)}`;
    }

    return `${currentUrl.origin}${currentUrl.pathname}`;
  }

  private getPublicationMediaUrl(publication: any): string | null {
    const multimedia = publication?.multimediaContainer || publication?.container?.multimediaContainer || [];
    const mediaCandidate = Array.isArray(multimedia) ? multimedia.find((item) => item?.route || item?.url) : null;

    return (
      mediaCandidate?.route ||
      mediaCandidate?.url ||
      publication?.media_url ||
      publication?.video_url ||
      publication?.container?.media_url ||
      publication?.container?.video_url ||
      null
    );
  }

  private getPublicationThumbnailUrl(publication: any): string | null {
    const multimedia = publication?.multimediaContainer || publication?.container?.multimediaContainer || [];
    const imageCandidate = Array.isArray(multimedia)
      ? multimedia.find((item) => item?.route && !this.isVideoUrl(item.route))
      : null;

    return (
      publication?.thumbnail_url ||
      publication?.thumbnailUrl ||
      publication?.cover_url ||
      publication?.coverUrl ||
      imageCandidate?.route ||
      imageCandidate?.url ||
      null
    );
  }

  private getDefaultSeoImage(): string {
    return 'https://static.wixstatic.com/media/8c5863_4657dcacb0584974846e3a942f7659fd~mv2.jpg/v1/fill/w_552,h_552,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/8c5863_4657dcacb0584974846e3a942f7659fd~mv2.jpg';
  }

  private isVideoUrl(url: string | null | undefined): boolean {
    return !!url && /\.(mp4|mov|m4v|webm|mkv|avi)(\?.*)?$/i.test(url);
  }

  private isVideoPublication(publication: any, mediaUrl?: string | null): boolean {
    if (publication?.publication_type?.toString().toLowerCase().includes('video')) {
      return true;
    }

    return this.isVideoUrl(mediaUrl || this.getPublicationMediaUrl(publication));
  }

  private getVideoMimeType(url: string): string {
    const cleanUrl = url.split('?')[0].toLowerCase();
    if (cleanUrl.endsWith('.webm')) {
      return 'video/webm';
    }
    if (cleanUrl.endsWith('.m4v')) {
      return 'video/x-m4v';
    }
    if (cleanUrl.endsWith('.mov')) {
      return 'video/quicktime';
    }
    if (cleanUrl.endsWith('.avi')) {
      return 'video/x-msvideo';
    }
    if (cleanUrl.endsWith('.mkv')) {
      return 'video/x-matroska';
    }
    return 'video/mp4';
  }

  private getPublicationUploadDate(publication: any): string | null {
    const rawDate = publication?.createdAt || publication?.created_at || publication?.container?.createdAt || publication?.container?.created_at;
    if (!rawDate) {
      return null;
    }

    const numericDate = Number(rawDate);
    if (!Number.isNaN(numericDate)) {
      const millis = numericDate > 1e12 ? numericDate : numericDate > 1e9 ? numericDate * 1000 : null;
      if (millis) {
        return new Date(millis).toISOString();
      }
    }

    const parsed = new Date(rawDate);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
  }

  private updateCanonical(url: string): void {
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', url);
  }

  private updateVideoJsonLd(publication: any, canonicalUrl: string, mediaUrl: string | null, thumbnailUrl: string, description: string, title: string, isVideo: boolean): void {
    if (!isVideo || !mediaUrl) {
      this.removeVideoJsonLd();
      return;
    }

    const structuredData: Record<string, any> = {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: title,
      description,
      url: canonicalUrl,
      contentUrl: mediaUrl,
      embedUrl: canonicalUrl,
      thumbnailUrl: thumbnailUrl || this.getDefaultSeoImage(),
      uploadDate: this.getPublicationUploadDate(publication) || new Date().toISOString(),
      publisher: {
        '@type': 'Organization',
        name: 'Laniakea',
        url: 'https://supercumulo.laniakea.tv/',
      },
    };

    const existingScript = document.getElementById(this.videoJsonLdScriptId) as HTMLScriptElement | null;
    const script = existingScript || document.createElement('script');
    script.id = this.videoJsonLdScriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);

    if (!existingScript) {
      document.head.appendChild(script);
    }
  }

  private removeVideoJsonLd(): void {
    const existingScript = document.getElementById(this.videoJsonLdScriptId);
    if (existingScript?.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
    }
  }

  private async bindDesktopWheelNavigation() {
    this.clearWheelListener();

    if (!this.slides) {
      return;
    }

    const host = (this.slides as any)?.el as HTMLElement;
    if (!host) {
      return;
    }

    const onWheel = async (e: WheelEvent) => {
      const direction = this.slideOpts?.direction === 'horizontal' ? 'horizontal' : 'vertical';
      const dx = e.deltaX ?? 0;
      const dy = e.deltaY ?? 0;
      const threshold = 24;
      const axisDominance = 1.2;

      const absX = Math.abs(dx);
      const absY = Math.abs(dy);
      const isVerticalIntent = absY > threshold && absY > absX * axisDominance;
      const isHorizontalIntent = absX > threshold && absX > absY * axisDominance;
      const shouldHandle = direction === 'vertical' ? isVerticalIntent : isHorizontalIntent;

      if (!shouldHandle) {
        return;
      }

      e.preventDefault();
      if (this.wheelLock) {
        return;
      }

      this.wheelLock = true;
      const amount = direction === 'vertical' ? dy : dx;

      try {
        if (amount > 0) {
          await this.slides.slideNext();
        } else {
          await this.slides.slidePrev();
        }
      } finally {
        setTimeout(() => {
          this.wheelLock = false;
        }, 330);
      }
    };

    host.addEventListener('wheel', onWheel, { passive: false });
    this.removeWheelListener = () => host.removeEventListener('wheel', onWheel as EventListener);
  }

  private clearWheelListener() {
    if (this.removeWheelListener) {
      this.removeWheelListener();
      this.removeWheelListener = null;
    }
  }

  ionViewDidEnter() {
  }

  //regalosconteo(){
    //this.modalController.create({
      //component:RegaloModalComponent
    //}).then((modal)=>{
     // modal.present()
    //})
  //}

  conteo(){

    this.lanzamiento = setInterval(() => {
      console.log(`lanzamiento en ${this.numero}`);
      this.numero--
      if (this.numero == 0) {
        clearInterval(this.lanzamiento)
      }
    }, 1200);

    console.log(`time ${this.numero}`);
  }



  async envioRegalo(pub) {
    
    console.log('sub', this.walletService.SubscriptionExpired);
    console.log('hub', this.HubbleExpired);
   
    //if (!this.HubbleExpired){
      this.walletService.SubscriptionExpired = false;
     // this.HubbleExpired = true;
    console.log('public', pub.id);
    console.log('pr', this.pr.id);
    const data = {
      publication_id: pub.id,
      sender_id: this.pr.id,
    };
  
    this.secureFeedback.begin('Autorizando regalo');
    try {
      const result = await this.request.createRequestPost('regalos', data);
      this.secureFeedback.succeed('Regalo enviado');
      pub.regalos++;
	  this.socialNotifications.notifyLocal(
		'Regalo enviado',
		`Tu regalo para @${pub?.userProfile?.username || 'Laniakea'} se envió correctamente.`,
		{ event_type: 'gift_sent', publication_id: pub.id },
	  );
      // If the server returned success, show a success Swal alert
      console.log('Gift sent successfully');
      Swal.fire({
        title: 'Regalo enviado a publicación con Success',
        icon: 'success',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        confirmButtonText: 'Understood',
        customClass: {
          confirmButton: 'swal-button'
        }
      });

      // Set HubbleExpired to false after 3 seconds
    //setTimeout(() => {
 
  this.sendNotificationRegalo(pub);
      // Fetch the updated gift count
      // ...
  
    } catch (error) {
      this.secureFeedback.fail('No se pudo enviar el regalo');
      console.error('Error sending gift:', error);
      //if (error.message === 'Sender currency not found.') {
        Swal.fire({
          title: 'Error al enviar el regalo',
          text: 'Revisa tu moneda configurada para envió de regalos',
          icon: 'error',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          confirmButtonText: 'Understood',
          customClass: {
            confirmButton: 'swal-button',
          },
        }).then(() => {
          // Open the ConfiguracionComponent after the user clicks "OK" in the Swal alert
          this.formService.sectionVer="regalos"  
        this.modalController.create({
          component:PublicacionesColeccionComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            profile_id: this.profile_id,
          }
        }).then((modal) => {
          modal.present();
        }).catch((error) => {
          console.error(error);
        });
        });
     // } else {
        // Handle other errors here
      //}
    }
 // }

  }
  sendNotificationRegalo(pub) {
   
		return new Promise((resolve, reject) => {
		  const notification = {
			title: 'Nuevo regalo recibido',
			body: `¡Has recibido un regalo de @${this.pr.username} en tu publicación!`,
			user_id: pub.userProfile.user_id,
	
		  };
	  
		  this.request.createRequestPost('GreatAtractorNotifications', notification)
			.then((data) => {
			  resolve(data);
			}).catch((error) => {
			  console.error('Failed to send notification:', error);
			  reject(error);
			});
		});
	  }
  
  
  
  
  
  
  private openKYCApplicationModal(pub) {
		console.log('openKYCApplicationModal called');
		this.walletService.KYC_validation().then((result_kyc) => {
			console.log('KYC_validation result:', result_kyc);
		  if (result_kyc['permit']) {
        if (Capacitor.getPlatform() !== 'web') {
        if (this.walletService.SubscriptionExpired !== true){
			this.envioRegalo(pub);
    }else if (this.walletService.SubscriptionExpired === true){
      this.RenewSuscription(pub);
    }
  }else{
    this.envioRegalo(pub);
  }

		  } else if (this.pr.kyc === "Sin Validar") {
			this.showPagoVerificacionModal();
		  } else{
			this.showPagoVerificacionModal();
		  }
		}).catch((error) => {
			console.error('KYC_validation error:', error);
		  console.error(error);
		});
	  }
    private showSliderInformationModal() {
      console.log('showSliderInformationModal called');
      this.modalController.create({
        component: SliderInformationComponent,
        cssClass: 'detailsInModal',
        canDismiss: true, // (forced globally for swipe close on all modals)
        componentProps: {
        pr: this.pr,
        },
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      }
      private showPagoVerificacionModal() {
        console.log('showPagoVerificacionModal called');
        console.log("entro al else if ");
        
        this.modalController.create({
          component: PagoVerificacionComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
          pr: this.pr
          }
        }).then((modal) => {
          modal.present();
        });
        }


  async presentToast(pub) {
    const audioFile = 'assets/sounds/send_sound.wav';
		const sound = new Howl({
		  src: [audioFile],
		  autoplay: true,
		  volume: 1.0, // Initial volume level (0.0 to 1.0)
		});
		sound.play();
    if (Capacitor.getPlatform() !== 'web') {//ios
      if(this.formService.face_id_active){
        if(this.formService.face_id_active){
          this.modalController.create({
            component: SeguridadComponent,
            cssClass: 'detailsInModal',
            canDismiss: true, // (forced globally for swipe close on all modals)
            componentProps: {
              face_id: true,
            }
            }).then((modal) => {
            modal.onDidDismiss().then((data) => {
              console.log('Modal dismissed:', data);
              if (data.data.role == 'success' ) {
              console.log('Output data:', data.role);
              // Handle the output data from the modal here
               // Call envioRegalo() here
               this.openKYCApplicationModal(pub);
              }
            });
            modal.present();
             // Listen to the output when the modal is dismissed
          
            }).catch((error) => {
            console.error(error);
            });
                              
          }else{
            this.enterPIN_to_enter_Hubble(pub);
          }
      }else{
        this.ionViewillEnter(pub);
      }
   
    }else{
      if(this.formService.face_id_active){
        this.modalController.create({
          component: SeguridadComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            face_id: true,
          }
          }).then((modal) => {
          modal.onDidDismiss().then((data) => {
            console.log('Modal dismissed:', data);
            if (data.data.role == 'success' ) {
            console.log('Output data:', data.role);
            // Handle the output data from the modal here
             // Call envioRegalo() here
             this.openKYCApplicationModal(pub);
            }
          });
          modal.present();
           // Listen to the output when the modal is dismissed
        
          }).catch((error) => {
          console.error(error);
          });
      }else{
        this.enterPIN_to_enter_Hubble(pub);
      }
     
    }

  }
  async enterPIN_to_enter_Hubble(pub){
    try {
      const { value: pin } = await Swal.fire({
        title: 'Facial ID desactivado. Ingresa PIN',
        text: `Por favor ingresa tu PIN alfanumรฉrico. Este PIN fue enviado a tu correo, si no tienes ninguno, puedes solicitarlo en Mรกs/Configuraciรณn/Seguridad/PIN de Hubble.`,
        icon: 'info',
        confirmButtonText: 'Validar',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        input: 'password',  // Change input type to 'password' to hide input content
        inputPlaceholder: 'Ingresa tu PIN',
        inputAttributes: {
        'aria-label': 'PIN'
        },
        showCancelButton: true,
        inputValidator: (value) => {
        if (!value) {
          return 'Debes ingresar un PIN!';
        }
        }
      });
    
      if (pin) {
        Swal.fire({
          title: 'Procesando...',
          text: 'Hubble estรก procesando.',
          icon: 'success',
          timer: 3900, // Show the alert for 3.9 seconds
          timerProgressBar: true,
          toast: true,
          position: 'top-end',
          showConfirmButton: false
          });
        const PIN = pin;  // Store the input value in a constant called PIN
        console.log("Entered PIN:", PIN);
        this.request.createRequestPost('enterToWalletWithPIN', { token: PIN }).then((response) => {
          if (response && typeof response === 'string') {
            try {
              response = JSON.parse(response);
              console.log('getRecordByToken ios:',response);
            } catch (error) {
              console.error("Error parsing data:", error);
            }
            }
          console.log("response:", response);
        if (response.title =='El email ha sido confirmado!'){
          Swal.fire({
            title: 'Procesando...',
            text: 'Hubble estรก procesando.',
            icon: 'success',
            timer: 3900, // Show the alert for 3.9 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-end',
            showConfirmButton: false
            });
            this.openKYCApplicationModal(pub);
        }else{
          Swal.fire({
            title: 'Procesando...',
            text: response.title,
            icon: 'error',
            timer: 3900, // Show the alert for 3.9 seconds
            timerProgressBar: true,
            toast: true,
            position: 'top-end',
            showConfirmButton: false
            });
        }
      }).catch((error) => {
        console.error('Failed to send request:', error);
      });
      }
    } catch (error) {
      console.error("Error displaying alert:", error);
      }
  }

  cancelarRegalo(){
    const audioFile = 'assets/sounds/send_sound.wav';
		const sound = new Howl({
		  src: [audioFile],
		  autoplay: true,
		  volume: 1.0, // Initial volume level (0.0 to 1.0)
		});
		sound.play();
     if(this.lanzamiento){
      clearInterval(this.lanzamiento)
      console.log("Cancelo Envio de Regalo");
      setTimeout(() => {
        this.mostrar=false
        this.numero=10

      }, 3000);

     }
  }



  async fetchPublications(user_id?: number){

    const result = await this.actualizacionservice.getPublications(null, false, (user_id) ? user_id: undefined, null, null);
    console.log("result en publication media template",result);
    return result;
  }

  validate_is_last_page(){
    let me = this;

    me.slides.getActiveIndex().then((slidesIndex) => {

      console.log('index chnaged slides', slidesIndex);
      this.formService.lkpublication.index_close = slidesIndex;
    });
    me.slides.isEnd().then(async (istrue) => {
      if (istrue) {
        me.NextSlide = 'Finish';

       
        await this.new_page();
      } else {

        me.NextSlide = 'Next';

      }
    });
  }

  async handleSlideChange() {
       /*
    if (this.showMoreTimeout) {
    clearTimeout(this.showMoreTimeout);
  }

  // 2. Set the new timeout and store its ID

  this.showMoreTimeout = setTimeout(() => {
   // this.formService.showMoreHidden = true;
    console.log("Timeout executed!"); // For debugging
  }, 1800);
  */

    this.formService.actual_publication=null;
    this.formService.changeMediaPeriodically=true;
    const currentIndex = await this.slides.getActiveIndex();
    this.activeSlideIndex = currentIndex;
    this.scheduleActionRailPositionSync();
    this.loadAuthorStoriesForPublication(this.publications?.[currentIndex]);
    this.formService.publication_template_index=currentIndex;
    await this.syncNativeInformationForPublication(this.publications?.[currentIndex]);
    await this.enforceActiveSlideMediaPlayback(currentIndex);
	if (this.slideInteractionStartedAt !== undefined) {
	  this.appQuality.markInteraction('publication-feed-swipe', this.slideInteractionStartedAt);
	  this.slideInteractionStartedAt = undefined;
	}
    if (this.previewMode) return;
    this.scheduleQualifiedActiveView(currentIndex);
    const totalSlides = await this.slides.length();

    // Start the next cursor request one publication before the end. The
    // current slide remains the visual anchor while the ten-item DOM window
    // is replaced, so prefetching does not move the user to another post.
    if (
      totalSlides >= 3
      && currentIndex === totalSlides - 2
      && this.usesCursorPagination()
      && this.cursorHasMore
      && !this.isFetchingPublications
      && !this.hasCachedPublicationsAfterVisibleWindow()
    ) {
      this.isFetchingPublications = true;
      void this.new_page(true);
    }

    // Check if the current slide is the last slide
    if (currentIndex === totalSlides - 1) {
      // Fetch more publications when reaching the last slide
     // See if we can satisfy the request from cached data first
 // Check if the last cached item matches the last currently displayed item
  const lastCurrent = this.publications[this.publications.length - 1];
  const lastCached  = this.cached_publications
    ? this.cached_publications[this.cached_publications.length - 1]
    : undefined;
 const lastIndexInCache = this.cached_publications.indexOf(lastCurrent);

  // If there are more items in cached_publications after the current last item…
  if (
  this.valueSelect !== 'profile' && lastCurrent !== lastCached
  ) {
    console.log('Loading next publications from cache…');

    // Fetch the next eight posts from the cache
    const nextItemsCount = 8;
    const nextItems: any[] = [];
    let nextIndex = lastIndexInCache + 1;
    while (
      nextItems.length < nextItemsCount &&
      nextIndex < this.cached_publications.length
    ) {
      nextItems.push(this.cached_publications[nextIndex]);
      nextIndex++;
    }

    // Append them to this.publications
    for (const item of nextItems) {
      this.publications.push(item);
    }

    // Trim from the front so we keep the list size at most 10
    // IMPORTANT: Never call slideTo() synchronously while mutating the *ngFor array.
    // This was causing the "jumps to last post when returning to first" bug
    // (especially noticeable when viewing profile posts from home/profile).
    while (this.publications.length > 10) {
      this.publications.shift();
    }

    // Let Angular update the DOM, then tell Swiper to recalculate its internal state
    Promise.resolve().then(async () => {
      if (this.slides) {
        await this.slides.update();
        // Keep the user roughly where they were (slide 1 after trimming the oldest)
        await this.slides.slideTo(1, 0, false);
        this.activeSlideIndex = 1;
        await this.enforceActiveSlideMediaPlayback(1);
        this.scheduleQualifiedActiveView(1);
      }
    });

    console.log('Updated publications (from cache):', this.publications);

    // Optionally, you may also want to update dom_publications or ChunkedPublications here
    // ...

  } else {
        if (this.externalPagination) {
          if (this.isFetchingPublications || !this.externalPaginationHasMore) {
            return;
          }
          this.isFetchingPublications = true;
          this.awaitingExternalPage = true;
          this.showFetchBanner('Alien intelligence craft', 'Retrieving the next publications from the Laniakea field.');
          this.requestNextPage.emit();
          return;
        }
     
        if(this.isFetchingPublications){
          return
        }
      if (this.usesCursorPagination() && !this.cursorHasMore) {
        return;
      }
      this.isFetchingPublications = true;
      void this.new_page(false);
    }
   } else if (currentIndex === 0 && this.cached_publications) {
    const currentFirst = this.publications[0];
    const currentFirstKey = this.getPublicationPaginationKey(currentFirst);
    const firstIndex = this.cached_publications.findIndex(
      (publication) => this.getPublicationPaginationKey(publication) === currentFirstKey
    );

    if (firstIndex <= 0) {
      console.log('Already at the earliest publication; no prior items to load.');
    } else {
      console.log('Loading prior publications from cache…');

      // Keep the current first post as the navigation anchor, with up to eight
      // exact cached predecessors and one successor. The successor prevents the
      // anchor from also being treated as the final slide and fetching forward.
      const startIndex = Math.max(0, firstIndex - 8);
      const endIndex = Math.min(this.cached_publications.length, firstIndex + 2);
      const previousWindow = this.cached_publications.slice(startIndex, endIndex);
      const anchorIndex = firstIndex - startIndex;

      this.publications = previousWindow;
      this.formService.publications = previousWindow;

      await Promise.resolve();
      await this.slides.update();
      await this.slides.slideTo(anchorIndex, 0, false);
      this.activeSlideIndex = anchorIndex;
      await this.enforceActiveSlideMediaPlayback(anchorIndex);
      console.log('Updated publications list (cached backward window):', this.publications);
    }
}

    
  }

  private async syncNativeInformationForPublication(
    publication: any,
    scrubberGeometry?: { scrubberVisible: boolean; scrubberTop?: number; webViewHeight?: number },
  ): Promise<void> {
    if (Capacitor.getPlatform() !== 'ios' || !publication || !this.isNativePublicationSurfaceEligible()) return;
    const measuredScrubberGeometry = scrubberGeometry ?? this.currentScrubberGeometry();
    const username = String(publication?.userProfile?.username || publication?.owner || publication?.username || 'Laniakea');
    const postedAgo = this.formatPublicationPostedAgo(publication);
    const result = await NativeLiquidGlass.setRegion({
      region: 'publication-info',
      visible: true,
	  suppressed: false,
      title: String(publication?.title || ''),
      description: String(publication?.description || ''),
      username,
      verified: publication?.Verified === true,
      postedAgo,
      expanded: this.formService.showMoreHidden !== true,
      price: Number(publication?.price) || 0,
      scrubberVisible: measuredScrubberGeometry.scrubberVisible,
      scrubberTop: measuredScrubberGeometry.scrubberTop,
      webViewHeight: measuredScrubberGeometry.webViewHeight,
    }).catch(() => ({ available: false }));
    document.body.classList.toggle('native-publication-info', result.available);
  }

  private currentScrubberGeometry(): { scrubberVisible: boolean; scrubberTop?: number; webViewHeight?: number } {
    const host = this.elementRef.nativeElement;
    const slides = host.querySelectorAll<HTMLElement>('ion-slide');
    const activeSlide = host.querySelector<HTMLElement>('.swiper-slide-active') || slides[this.activeSlideIndex];
    const scrubberBounds = activeSlide?.querySelector<HTMLElement>('.video-scrubber-shell')?.getBoundingClientRect();
    if (!scrubberBounds || scrubberBounds.width <= 0 || scrubberBounds.height <= 0) {
      return { scrubberVisible: false };
    }
    return {
      scrubberVisible: true,
      scrubberTop: scrubberBounds.top,
      webViewHeight: window.innerHeight,
    };
  }

  private formatPublicationPostedAgo(publication: any): string {
    const timestamp = this.publicationTimestamp(publication);
    if (!timestamp) return '';
    const seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
    if (seconds < 60) return 'ahora';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `hace ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `hace ${hours} h`;
    const days = Math.floor(hours / 24);
    return `hace ${days} día${days === 1 ? '' : 's'}`;
  }

  private publicationTimestamp(publication: any): number | null {
    const values = [
      publication?.createdAt,
      publication?.created_at,
      publication?.container?.createdAt,
      publication?.container?.created_at,
    ];
    for (const value of values) {
      const numeric = typeof value === 'number' || (typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value.trim()))
        ? Number(value)
        : NaN;
      const timestamp = Number.isFinite(numeric)
        ? (numeric > 0 && numeric < 100000000000 ? numeric * 1000 : numeric)
        : new Date(value as any).getTime();
      // A missing/zero timestamp must not become 1 Jan 1970. Publications in
      // this product are modern records, so reject invalid legacy placeholders.
      if (Number.isFinite(timestamp) && timestamp >= 946684800000) return timestamp;
    }
    return null;
  }

  profilePhotoFor(publication: any): string {
    let source: any = publication?.userProfile?.profile_photo || publication?.profile_photo || publication?.user?.profile_photo;
    for (let depth = 0; depth < 3 && source && typeof source === 'object'; depth++) {
      source = source.url || source.route || source.path || source.src || source.localUrl || source.photo_url || source.photoUrl || source.profile_photo || source.profilePhoto;
    }
    const value = typeof source === 'string' ? source.trim() : '';
    if (!value || value === 'null' || value === 'undefined') return 'assets/icon/usuario.png';
    if (/^(https?:|blob:|data:|capacitor:|file:)/i.test(value) || value.startsWith('assets/')) return value;
    return `https://laniakea-multimedia.s3.amazonaws.com/${value.replace(/^\/+/, '')}`;
  }

  onAuthorAvatarImageError(event: Event): void {
    const image = event.target as any;
    if (image && image.src !== 'assets/icon/usuario.png') image.src = 'assets/icon/usuario.png';
  }

  hasAuthorStories(publication: any): boolean {
    return this.authorStoriesForPublication(publication).length > 0;
  }

  hasUnseenAuthorStories(publication: any): boolean {
    const stories = this.authorStoriesForPublication(publication);
    return stories.length > 0 && this.publicationService.hasUnseenStories(stories, this.formService.profile);
  }

  authorAvatarLabel(publication: any): string {
    const username = publication?.userProfile?.username || publication?.username || 'este usuario';
    if (this.hasAuthorStories(publication)) return `Abrir historias de ${username}`;
    return this.isFollowingPublicationAuthor(publication) || this.isPublicationOwner(publication)
      ? `Abrir perfil de ${username}`
      : `Seguir a ${username} y abrir su perfil`;
  }

  async onAuthorAvatarClick(event: Event, publication: any): Promise<void> {
    event.stopPropagation();
    const stories = this.authorStoriesForPublication(publication);
    if (stories.length) {
      const modal = await this.modalController.create({
        component: StoryViewerComponent,
        cssClass: 'detailsInModal',
        canDismiss: true,
        componentProps: { stories, tapped: 0 },
      });
      await modal.present();
      return;
    }

    if (!this.isPublicationOwner(publication) && !this.isFollowingPublicationAuthor(publication)) {
      const userId = this.publicationAuthorUserId(publication);
      if (userId) {
        try {
          await this.friendshipService.createRelation({ relationUserId: String(userId), relationType: '3' });
          publication.Relative = { ...(publication.Relative || {}), followButton: { text: 'Siguiendo' } };
        } catch (error) {
          console.warn('Could not follow publication author before opening profile.', error);
        }
      }
    }
    const userId = this.publicationAuthorUserId(publication);
    if (userId) await this.navCtrl.navigateForward(`home/profile/${userId}`);
  }

  private authorStoriesForPublication(publication: any): PublicationClass[] {
    return this.authorStoriesByPublicationId[this.publicationStoryKey(publication)] || [];
  }

  private loadAuthorStoriesForPublication(publication: any): void {
    const key = this.publicationStoryKey(publication);
    if (!publication || this.authorStoriesLoading.has(key)) return;
    const userId = this.publicationAuthorUserId(publication);
    const profileId = publication?.userProfile?.profile_id ?? publication?.profile_id;
    if (!userId && !profileId) return;
    this.authorStoriesLoading.add(key);
    const username = publication?.userProfile?.username || publication?.username;
    const profilePhoto = this.profilePhotoFor(publication);
    this.authorStoriesByPublicationId[key] = this.publicationService.getStoriesForAuthor(
      [userId], [username], profilePhoto, [profileId]
    ) || [];
    this.publicationService.loadStoriesForAuthor(profileId, [userId], [username], profilePhoto)
      .then(stories => this.authorStoriesByPublicationId[key] = Array.isArray(stories) ? stories : [])
      .finally(() => this.authorStoriesLoading.delete(key));
  }

  private publicationStoryKey(publication: any): string {
    return String(publication?.id || this.publicationAuthorUserId(publication) || publication?.userProfile?.profile_id || 'unknown');
  }

  private publicationAuthorUserId(publication: any): any {
    return publication?.userProfile?.user_id ?? publication?.user_id ?? publication?.userProfile?.id ?? publication?.user?.id;
  }

  private isPublicationOwner(publication: any): boolean {
    const authorId = Number(this.publicationAuthorUserId(publication));
    const currentId = Number(this.formService.profile?.user_id ?? this.formService.profile?.id);
    return Boolean(publication?.owner) || (Number.isFinite(authorId) && authorId > 0 && authorId === currentId);
  }

  private isFollowingPublicationAuthor(publication: any): boolean {
    const state = publication?.Relative?.followButton?.text || publication?.Relative?.text || publication?.followButton?.text;
    return publication?.is_following === true || publication?.following === true || state === 'Siguiendo' || state === 'Following';
  }

  private async activateNativePublicationChromeForVisibleSurface(): Promise<void> {
    if (Capacitor.getPlatform() !== 'ios' || this.previewMode || !this.isNativePublicationHostVisible()) return;
    document.body.classList.remove('native-publication-overlay-suspended');
    await NativeLiquidGlass.setPublicationInfoSuppressed({ suppressed: false })
      .catch(() => ({ available: false }));
  }

  private isNativePublicationSurfaceEligible(): boolean {
	if (document.body.classList.contains('native-publication-overlay-suspended')) return false;
	return this.isNativePublicationHostVisible();
  }

  private isNativePublicationHostVisible(): boolean {
    const host = this.elementRef.nativeElement;
    if (!host?.isConnected || host.closest('.ion-page-hidden, [aria-hidden="true"]')) return false;
    const style = getComputedStyle(host);
    const bounds = host.getBoundingClientRect();
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && bounds.width > 0
      && bounds.height > 0;
  }

  @HostListener('window:nativePublicationContextRestored')
  async handleNativePublicationContextRestored(): Promise<void> {
    if (!this.isNativePublicationSurfaceEligible()) return;
    const activeIndex = this.slides ? await this.slides.getActiveIndex().catch(() => this.activeSlideIndex) : this.activeSlideIndex;
    this.activeSlideIndex = Number.isFinite(Number(activeIndex)) ? Number(activeIndex) : 0;
    await this.syncNativeInformationForPublication(this.publications?.[this.activeSlideIndex]);
  }
  ionSlideWillChange(){
	this.slideInteractionStartedAt = typeof performance !== 'undefined' ? performance.now() : Date.now();
	this.appQuality.startFrameSample('publication-feed-swipe', 750);
    this.publicationSwipe.emit();
    // Query all video and audio elements
this.formService.muteAllMedia();
  }

  private setShowMoreHidden(hidden: boolean): void {
    this.formService.showMoreHidden = hidden;
    this.formService.showMorePreferenceChanged = true;
  }

  private bindActiveSlideMediaGuard(): void {
    if (this.removeMediaPlaybackGuard) return;
    const guard = (event: Event) => {
      const media = event.target as HTMLMediaElement;
      if (!(media instanceof HTMLMediaElement) || !this.isMediaInsideThisTemplate(media)) return;
      const owningSlide = media.closest('ion-slide.slide');
      const activeSlide = this.getActivePublicationSlide(this.activeSlideIndex);
      if (!owningSlide || owningSlide !== activeSlide || media !== this.activePlayableMedia) {
        media.muted = true;
        media.pause();
      }
    };
    document.addEventListener('play', guard, true);
    this.removeMediaPlaybackGuard = () => document.removeEventListener('play', guard, true);
  }

  private isMediaInsideThisTemplate(media: HTMLMediaElement): boolean {
    const host = (this.slides as any)?.el as HTMLElement | undefined;
    return !!host?.contains(media);
  }

  private getActivePublicationSlide(index: number): HTMLElement | null {
    const host = (this.slides as any)?.el as HTMLElement | undefined;
    if (!host) return null;
    const slides = Array.from(host.querySelectorAll(':scope > .swiper-wrapper > ion-slide.slide')) as HTMLElement[];
    return slides[index]
      || host.querySelector('ion-slide.slide.swiper-slide-active') as HTMLElement | null;
  }

  public async refreshActiveMediaPlayback(): Promise<void> {
    await this.enforceActiveSlideMediaPlayback(this.activeSlideIndex);
  }

  private async enforceActiveSlideMediaPlayback(index: number = this.activeSlideIndex): Promise<void> {
    await Promise.resolve();
    await this.waitForMediaFrame();
    if (index !== this.activeSlideIndex) return;
    const host = (this.slides as any)?.el as HTMLElement | undefined;
    const activeSlide = this.getActivePublicationSlide(index);
    if (!host || !activeSlide) return;

    const allMedia = Array.from(host.querySelectorAll('video, audio')) as HTMLMediaElement[];
    const activeMedia = allMedia.filter((media) => activeSlide.contains(media));
    const nestedActiveMedia = activeSlide.querySelector(
      'ion-slide.slideSec.swiper-slide-active video, ion-slide.slideSec.swiper-slide-active audio'
    ) as HTMLMediaElement | null;
    const visibleActiveMedia = activeMedia.filter((media) => {
      const rect = media.getBoundingClientRect();
      const style = getComputedStyle(media);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
    const playable = nestedActiveMedia || visibleActiveMedia
      .sort((a, b) => {
        const aRect = a.getBoundingClientRect();
        const bRect = b.getBoundingClientRect();
        return (bRect.width * bRect.height) - (aRect.width * aRect.height);
      })[0] || activeMedia[0] || null;
    this.activePlayableMedia = playable;

    const nextVideo = this.nextVideoToPreload(index);

    allMedia.forEach((media) => {
      if (media === playable || media === nextVideo) return;
      this.releaseMediaSource(media);
    });

    if (playable) {
      this.attachMediaSource(playable);
      playable.muted = false;
      playable.volume = 1;
      void playable.play().catch(() => {
        // iOS may still require a direct gesture; the guard nevertheless keeps
        // every non-active publication silent and paused.
      });
    }
    this.prepareNextVideo(nextVideo);
  }

  private nextVideoToPreload(index: number): HTMLVideoElement | null {
    if (!this.preloadNextVideo || document.hidden) return null;
    const host = (this.slides as any)?.el as HTMLElement | undefined;
    const slides = host?.querySelectorAll(':scope > .swiper-wrapper > ion-slide.slide');
    const nextSlide = slides?.[index + 1];
    if (!nextSlide) return null;
    // For a carousel, preload only the item that will actually be visible.
    // An image-first post must not fetch its later videos or locked previews.
    const nextMediaSlide = nextSlide.querySelector('ion-slide.slideSec.swiper-slide-active')
      || nextSlide.querySelector('ion-slide.slideSec');
    return (nextMediaSlide || nextSlide).querySelector<HTMLVideoElement>('video[data-feed-preload]');
  }

  private prepareNextVideo(video: HTMLVideoElement | null): void {
    const previous = this.preloadedVideo;
    this.preloadedVideo = video;
    if (previous && previous !== video && previous !== this.activePlayableMedia) {
      this.releaseMediaSource(previous);
    }
    if (!video) return;
    video.muted = true;
    video.pause();
    video.removeAttribute('autoplay');
    video.preload = 'auto';
    this.attachMediaSource(video);
  }

  public isPreloadedVideo(video: HTMLVideoElement): boolean {
    return video === this.preloadedVideo;
  }

  @HostListener('document:visibilitychange')
  onFeedPreloadVisibilityChange(): void {
    this.prepareNextVideo(this.nextVideoToPreload(this.activeSlideIndex));
  }

  private attachMediaSource(media: HTMLMediaElement): void {
    const source = media.querySelector('source[data-media-src]') as HTMLSourceElement | null;
    const sourceUrl = source?.dataset.mediaSrc || media.dataset.mediaSrc;
    if (!sourceUrl) return;

    const currentSource = source?.getAttribute('src') || media.getAttribute('src');
    if (currentSource === sourceUrl) return;

    if (source) source.setAttribute('src', sourceUrl);
    else media.setAttribute('src', sourceUrl);
    media.load();
  }

  private releaseMediaSource(media: HTMLMediaElement): void {
    if (media === this.preloadedVideo) this.preloadedVideo = null;
    media.preload = 'none';
    media.muted = true;
    media.pause();
    media.removeAttribute('autoplay');
    const sources = Array.from(media.querySelectorAll('source')) as HTMLSourceElement[];
    const hadSource = media.hasAttribute('src') || sources.some((source) => source.hasAttribute('src'));
    media.removeAttribute('src');
    sources.forEach((source) => source.removeAttribute('src'));
    if (hadSource) {
      try {
        media.load();
      } catch {}
    }
  }

  private releaseAllPublicationMedia(): void {
    this.prepareNextVideo(null);
    const host = (this.slides as any)?.el as HTMLElement | undefined;
    if (!host) return;
    const media = Array.from(host.querySelectorAll('video, audio')) as HTMLMediaElement[];
    media.forEach((element) => this.releaseMediaSource(element));
  }

  private waitForMediaFrame(): Promise<void> {
    this.cancelPendingMediaFrame();
    return new Promise<void>((resolve) => {
      this.mediaPlaybackFrameResolve = resolve;
      this.mediaPlaybackFrameId = requestAnimationFrame(() => {
        this.mediaPlaybackFrameId = null;
        this.mediaPlaybackFrameResolve = null;
        resolve();
      });
    });
  }

  private cancelPendingMediaFrame(): void {
    if (this.mediaPlaybackFrameId !== null) cancelAnimationFrame(this.mediaPlaybackFrameId);
    this.mediaPlaybackFrameId = null;
    const resolve = this.mediaPlaybackFrameResolve;
    this.mediaPlaybackFrameResolve = null;
    resolve?.();
  }

  async new_page(prefetch: boolean = false) {
    const selection = this.paginationSelection();
    const isProfilePagination = selection === 'profile';
    const useCursorPagination = this.usesCursorPagination();
    const previousPage = isProfilePagination
      ? this.profilePaginationPage
      : this.actualizacionservice.current_page;
    const requestedPage = previousPage + 1;
    const shouldReportProgress = !prefetch;

    this.isFetchingPublications = true;
    try {
      if (shouldReportProgress) {
        this.showFetchBanner('Alien intelligence craft', 'Retrieving the next publications from the Laniakea field.');
      }

      if (!isProfilePagination && !useCursorPagination) {
        this.actualizacionservice.current_page = requestedPage;
      }

      let publicationsFromServer: any[] = [];
      if (useCursorPagination) {
        publicationsFromServer = await this.fetchNextCursorPublications();
      } else if (selection === 'Seguidores') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'Parati');
      } else if (selection === 'profile') {
        publicationsFromServer = await this.actualizacionservice.getProfilePublications(
          null,
          false,
          this.profile_id,
          false,
          null,
          this.actual_publication_section === 'Reciente'
            ? undefined
            : this.actual_publication_section,
          requestedPage,
        );
      } else if (selection === 'Para todos') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'paraTodos');
      } else if (selection === 'ColeccionRegalos') {
        publicationsFromServer = await this.actualizacionservice.getPublicationsGifted(null, false, null, false, null);
      } else if (selection === 'ColeccionCompras') {
        publicationsFromServer = await this.actualizacionservice.getPublicationsPaid(null, false, null, false, null);
      } else if (selection === 'Guardado') {
        publicationsFromServer = await this.actualizacionservice.getPublicationsSave(null, false, null, false, null);
      } else if (selection === 'MENU') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, null);
      } else if (selection === 'earth') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'earth');
      } else if (selection === 'epoch') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'epoch');
      } else if (selection === 'eclipse') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'eclipse');
      } else if (selection === 'land') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'land');
      } else if (selection === 'lkfilm') {
        publicationsFromServer = await this.actualizacionservice.getAIPublications(null, false, null, false, 'LKFE');
      } else if (selection === 'playlist') {
        publicationsFromServer = await this.actualizacionservice.getPlaylistPublications(
          null,
          false,
          null,
          false,
          this.formService.actual_playlist,
        );
      }

      if (!publicationsFromServer || publicationsFromServer.length === 0) {
        if (!isProfilePagination && !useCursorPagination) {
          this.actualizacionservice.current_page = previousPage;
        }
        if (shouldReportProgress) {
          this.updateFetchBanner('Signal scan complete', 'No additional publications were returned yet. Hold position for another swipe.');
          this.hideFetchBanner(1400);
        }
        return;
      }

      const currentPublicationKeys = new Set(
        (this.cached_publications || this.publications || []).map((publication) => this.getPublicationPaginationKey(publication))
      );
      const appendedPublications: any[] = [];

      publicationsFromServer.forEach((publication) => {
        let canAppend = true;
        if ('quienpuedever' in publication) {
          if (selection === 'Para todos') {
            canAppend = publication['quienpuedever'].includes('Para todos');
          } else if (selection === 'Seguidores') {
            canAppend = publication['quienpuedever'].includes('Seguidores');
          }
        }

        const publicationKey = this.getPublicationPaginationKey(publication);
        if (canAppend && !currentPublicationKeys.has(publicationKey)) {
          currentPublicationKeys.add(publicationKey);
          appendedPublications.push(publication);
        }
      });

      if (appendedPublications.length === 0) {
        if (!isProfilePagination && !useCursorPagination) {
          this.actualizacionservice.current_page = previousPage;
        }
        if (shouldReportProgress) {
          this.updateFetchBanner('Signal scan complete', 'No new publications were returned yet. Hold position for another swipe.');
          this.hideFetchBanner(1400);
        }
        return;
      }

      const visibleBeforeAppend = [...(this.publications || [])];
      const liveIndex = this.slides
        ? await this.slides.getActiveIndex().catch(() => this.activeSlideIndex)
        : this.activeSlideIndex;
      const anchorPublication = visibleBeforeAppend[liveIndex]
        || visibleBeforeAppend[visibleBeforeAppend.length - 1];
      const movedAwayFromPrefetchEdge = prefetch
        && liveIndex < Math.max(0, visibleBeforeAppend.length - 2);

      this.cached_publications = this.mergeUniquePublicationPages([
        ...(this.cached_publications || []),
        ...appendedPublications,
      ]);

      // If the user swiped backwards while the request was in flight, retain
      // the current DOM exactly as-is. The prefetched records remain in cache
      // and are consumed when the user reaches the end again.
      if (movedAwayFromPrefetchEdge) {
        return;
      }

      const previousVisibleLength = visibleBeforeAppend.length;
      this.publications = [...visibleBeforeAppend, ...appendedPublications];
      if (isProfilePagination) {
        this.profilePaginationPage = requestedPage;
      } else {
        this.publications = this.buildVisibleWindow(this.publications);
      }

      this.formService.publications = this.publications;
      await Promise.resolve();
      await this.slides.update();

      let targetIndex: number;
      if (isProfilePagination) {
        targetIndex = Math.min(previousVisibleLength, this.publications.length - 1);
      } else {
        const anchorKey = this.getPublicationPaginationKey(anchorPublication);
        const anchorIndex = this.publications.findIndex(
          (publication) => this.getPublicationPaginationKey(publication) === anchorKey
        );
        targetIndex = anchorIndex >= 0 ? anchorIndex : Math.min(1, this.publications.length - 1);
      }

      await this.slides.slideTo(Math.max(0, targetIndex), 0, false);
      this.activeSlideIndex = Math.max(0, targetIndex);
      this.formService.publication_template_index = this.activeSlideIndex;
      await this.syncNativeInformationForPublication(this.publications[this.activeSlideIndex]);
      await this.enforceActiveSlideMediaPlayback(this.activeSlideIndex);
      this.scheduleQualifiedActiveView(this.activeSlideIndex);

      if (shouldReportProgress) {
        this.updateFetchBanner('Signal received', `${appendedPublications.length} new publication${appendedPublications.length === 1 ? '' : 's'} synchronized.`);
        this.hideFetchBanner(520);
      }
    } catch (error) {
      if (!isProfilePagination && !useCursorPagination) {
        this.actualizacionservice.current_page = previousPage;
      }
      console.error('Error fetching publications:', error);
      if (shouldReportProgress) {
        this.updateFetchBanner('Signal interrupted', 'The intelligence craft could not retrieve new publications. Please try again.');
        this.hideFetchBanner(1600);
      }
    } finally {
      this.isFetchingPublications = false;
    }
  }

  private getPublicationPaginationKey(publication: any): string {
    const identifier = publication?.id
      ?? publication?.publication_id
      ?? publication?.uuid
      ?? publication?.slug;

    if (identifier !== undefined && identifier !== null) {
      return String(identifier);
    }

    return JSON.stringify(publication);
  }

  private mergeUniquePublicationPages(publications: any[]): any[] {
    const seen = new Set<string>();
    return (publications || []).filter((publication) => {
      const key = this.getPublicationPaginationKey(publication);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  private paginationSelection(): string {
    return String(this.valueSelect ?? this.formService.valueSelect ?? '');
  }

  private usesCursorPagination(): boolean {
    if (this.previewMode || this.externalPagination) return false;
    const selection = this.paginationSelection();
    // Cursor pagination belongs only to discovery feeds. An allowlist is
    // intentional: profile posts/reposts, liked-state views, bookmarks,
    // purchases, gifts, playlists, previews, and future collection selectors
    // must continue using their own endpoint instead of silently falling back
    // to publications_AI.
    const enabled = [
      'MENU',
      'Seguidores',
      'Para todos',
      'lkfilm',
      'earth',
      'epoch',
      'eclipse',
      'land',
    ].includes(selection);
    if (enabled) this.ensureCursorContext();
    return enabled;
  }

  private cursorPublicationType(): string | undefined {
    switch (this.paginationSelection()) {
      case 'Seguidores':
        return 'Parati';
      case 'Para todos':
        return 'paraTodos';
      case 'lkfilm':
        return 'LKFE';
      case 'earth':
      case 'epoch':
      case 'eclipse':
      case 'land':
        return this.paginationSelection();
      default:
        return undefined;
    }
  }

  private resetCursorPagination(): void {
    this.nextPublicationCursor = null;
    this.cursorHasMore = true;
    this.cursorContextKey = null;
  }

  private ensureCursorContext(): void {
    const profileId = this.formService.profile?.id ?? this.formService.profile?.user_id ?? 'public';
    const contextKey = `${this.paginationSelection()}|${profileId}`;
    if (this.cursorContextKey === contextKey) return;
    this.nextPublicationCursor = null;
    this.cursorHasMore = true;
    this.cursorContextKey = contextKey;
  }

  private async fetchNextCursorPublications(): Promise<any[]> {
    this.ensureCursorContext();
    if (!this.cursorHasMore) return [];

    const knownKeys = new Set(
      (this.cached_publications || this.publications || []).map(
        (publication) => this.getPublicationPaginationKey(publication)
      )
    );
    const newPublications: any[] = [];

    // The first cursor page can overlap the page that opened the viewer. Move
    // through a few cursor pages until at least one genuinely new record is
    // found; subsequent requests continue directly from the stored cursor.
    for (let attempt = 0; attempt < 4 && this.cursorHasMore && newPublications.length === 0; attempt++) {
      const requestedCursor = this.nextPublicationCursor;
      const response = await this.actualizacionservice.getAIPublicationsByCursor(
        requestedCursor || undefined,
        undefined,
        this.cursorPublicationType(),
      );

      this.nextPublicationCursor = response.nextCursor;
      this.cursorHasMore = response.hasMore && !!response.nextCursor;
      response.publications.forEach((publication) => {
        const key = this.getPublicationPaginationKey(publication);
        if (!knownKeys.has(key)) {
          knownKeys.add(key);
          newPublications.push(publication);
        }
      });

      // A malformed/non-advancing cursor must not create an infinite request
      // loop when the user remains on the final slide.
      if (response.hasMore && response.nextCursor === requestedCursor) {
        this.cursorHasMore = false;
      }
    }

    return newPublications;
  }

  private hasCachedPublicationsAfterVisibleWindow(): boolean {
    if (!this.cached_publications?.length || !this.publications?.length) return false;
    const lastVisibleKey = this.getPublicationPaginationKey(
      this.publications[this.publications.length - 1]
    );
    const lastVisibleCacheIndex = this.cached_publications.findIndex(
      (publication) => this.getPublicationPaginationKey(publication) === lastVisibleKey
    );
    return lastVisibleCacheIndex >= 0
      && lastVisibleCacheIndex < this.cached_publications.length - 1;
  }

  RedundancyNewPublications(publications) {
    const chunkSize = 1; // Define your desired chunk size here
    const chunkedArray = [];
    
    for (let i = 0; i < publications.length; i += chunkSize) {
      const chunk = publications.slice(i, i + chunkSize);
      chunkedArray.push(chunk);
    }
    
    return chunkedArray;
  }

  private buildVisibleWindow(publications: any[]) {
    const maxDomItems = 10;
    const startIndex = Math.max(0, publications.length - maxDomItems);
    return publications.slice(startIndex);
  }

  private buildExternalPaginationWindow(publications: any[], previousLength: number): any[] {
    const maxDomItems = 10;
    // Keep the publication that triggered the fetch at index zero, followed by
    // the newly returned publications. This gives Swiper a stable anchor.
    const anchorIndex = Math.max(0, Math.min(previousLength - 1, publications.length - 1));
    return publications.slice(anchorIndex, anchorIndex + maxDomItems);
  }

  private handleExternalPaginationUpdate(previousLength: number, nextLength: number, anchorPublication?: any) {
    if (!this.awaitingExternalPage || nextLength <= previousLength) {
      return;
    }

    this.awaitingExternalPage = false;
    this.isFetchingPublications = false;
    this.updateFetchBanner('Signal received', `${nextLength - previousLength} new publication${nextLength - previousLength === 1 ? '' : 's'} synchronized.`);
    this.hideFetchBanner(520);

    void this.advanceAfterExternalSlidesRender(anchorPublication);
  }

  private async advanceAfterExternalSlidesRender(anchorPublication?: any): Promise<void> {
    // Wait for Angular's *ngFor and Ionic's Swiper wrapper to receive the newly
    // returned publications before changing the active slide.
    await Promise.resolve();
    await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
    if (!this.slides) return;
    await this.slides.update();

    const anchorKey = this.getPublicationPaginationKey(anchorPublication);
    const anchorIndex = Math.max(0, this.publications.findIndex(
      (publication) => this.getPublicationPaginationKey(publication) === anchorKey
    ));
    const targetIndex = Math.min(anchorIndex + 1, this.publications.length - 1);
    if (targetIndex <= anchorIndex) return;
    await this.slides.slideTo(targetIndex, 699, true);
    this.activeSlideIndex = targetIndex;
    this.formService.publication_template_index = targetIndex;
  }

  private handleExternalPaginationStatusChange() {
    if (!this.awaitingExternalPage || this.externalPaginationLoading) {
      return;
    }

    this.awaitingExternalPage = false;
    this.isFetchingPublications = false;

    if (!this.externalPaginationHasMore) {
      this.updateFetchBanner('Signal scan complete', 'No additional publications were returned yet. Hold position for another swipe.');
      this.hideFetchBanner(1400);
      return;
    }

    this.hideFetchBanner();
  }

  private showFetchBanner(title: string, message: string) {
    // A previous success/error banner may still have delayed hide/removal timers.
    // Cancel them before reusing the banner for the next pagination request.
    if (this.fetchBannerHideTimeout) {
      clearTimeout(this.fetchBannerHideTimeout);
      this.fetchBannerHideTimeout = null;
    }
    if (this.fetchBannerRemoveTimeout) {
      clearTimeout(this.fetchBannerRemoveTimeout);
      this.fetchBannerRemoveTimeout = null;
    }

    this.fetchBannerClosing = false;
    this.fetchBannerTitle = title;
    this.fetchBannerMessage = message;
    this.fetchBannerVisible = true;
    this.renderFetchBannerDom();
  }

  private updateFetchBanner(title: string, message: string) {
    this.fetchBannerTitle = title;
    this.fetchBannerMessage = message;
    this.renderFetchBannerDom();
  }

  private hideFetchBanner(delayMs: number = 0) {
    if (this.fetchBannerHideTimeout) {
      clearTimeout(this.fetchBannerHideTimeout);
      this.fetchBannerHideTimeout = null;
    }
    if (this.fetchBannerRemoveTimeout) {
      clearTimeout(this.fetchBannerRemoveTimeout);
      this.fetchBannerRemoveTimeout = null;
    }

    this.fetchBannerHideTimeout = setTimeout(() => {
      if (!this.fetchBannerVisible) {
        return;
      }
      this.fetchBannerClosing = true;
      if (this.fetchBannerEl) {
        this.renderer.setStyle(this.fetchBannerEl, 'opacity', '0');
        this.renderer.setStyle(this.fetchBannerEl, 'transform', 'translate(-50%, 18px)');
      }
      this.fetchBannerRemoveTimeout = setTimeout(() => {
        this.fetchBannerVisible = false;
        this.fetchBannerClosing = false;
        this.removeFetchBannerDom();
      }, 320);
    }, delayMs);
  }

  private renderFetchBannerDom() {
    if (typeof document === 'undefined' || !this.fetchBannerVisible) {
      return;
    }

    if (!this.fetchBannerEl) {
      this.fetchBannerEl = this.renderer.createElement('div');
      this.renderer.setStyle(this.fetchBannerEl, 'position', 'fixed');
      this.renderer.setStyle(this.fetchBannerEl, 'left', '50%');
      this.renderer.setStyle(this.fetchBannerEl, 'bottom', '108px');
      this.renderer.setStyle(this.fetchBannerEl, 'transform', 'translateX(-50%)');
      this.renderer.setStyle(this.fetchBannerEl, 'width', 'min(520px, calc(100vw - 28px))');
      this.renderer.setStyle(this.fetchBannerEl, 'padding', '12px 16px');
      this.renderer.setStyle(this.fetchBannerEl, 'border-radius', '16px');
      this.renderer.setStyle(this.fetchBannerEl, 'border', '1px solid rgba(137, 202, 255, 0.18)');
      this.renderer.setStyle(this.fetchBannerEl, 'background', 'rgba(7, 16, 37, 0.92)');
      this.renderer.setStyle(this.fetchBannerEl, 'box-shadow', '0 18px 36px rgba(0, 0, 0, 0.35)');
      this.renderer.setStyle(this.fetchBannerEl, 'backdrop-filter', 'none');
      this.renderer.setStyle(this.fetchBannerEl, '-webkit-backdrop-filter', 'none');
      this.renderer.setStyle(this.fetchBannerEl, 'z-index', '10002');
      this.renderer.setStyle(this.fetchBannerEl, 'display', 'flex');
      this.renderer.setStyle(this.fetchBannerEl, 'flex-direction', 'column');
      this.renderer.setStyle(this.fetchBannerEl, 'gap', '4px');
      this.renderer.setStyle(this.fetchBannerEl, 'opacity', '0');
      this.renderer.setStyle(this.fetchBannerEl, 'transition', 'opacity 180ms ease, transform 180ms ease');

      this.fetchBannerTitleEl = this.renderer.createElement('div');
      this.renderer.setStyle(this.fetchBannerTitleEl, 'color', '#9ae9ff');
      this.renderer.setStyle(this.fetchBannerTitleEl, 'font-size', '0.74rem');
      this.renderer.setStyle(this.fetchBannerTitleEl, 'font-weight', '700');
      this.renderer.setStyle(this.fetchBannerTitleEl, 'letter-spacing', '0.08em');
      this.renderer.setStyle(this.fetchBannerTitleEl, 'text-transform', 'uppercase');

      this.fetchBannerMessageEl = this.renderer.createElement('div');
      this.renderer.setStyle(this.fetchBannerMessageEl, 'color', '#eef4ff');
      this.renderer.setStyle(this.fetchBannerMessageEl, 'font-size', '0.92rem');
      this.renderer.setStyle(this.fetchBannerMessageEl, 'line-height', '1.35');

      this.renderer.appendChild(this.fetchBannerEl, this.fetchBannerTitleEl);
      this.renderer.appendChild(this.fetchBannerEl, this.fetchBannerMessageEl);
      this.renderer.appendChild(document.body, this.fetchBannerEl);
    }

    this.fetchBannerClosing = false;
    this.fetchBannerTitleEl!.textContent = this.fetchBannerTitle;
    this.fetchBannerMessageEl!.textContent = this.fetchBannerMessage;
    this.renderer.setStyle(this.fetchBannerEl, 'display', 'flex');
    this.renderer.setStyle(this.fetchBannerEl, 'opacity', '1');
    this.renderer.setStyle(this.fetchBannerEl, 'transform', 'translate(-50%, 0)');
  }

  private removeFetchBannerDom(immediate: boolean = false) {
    if (this.fetchBannerHideTimeout) {
      clearTimeout(this.fetchBannerHideTimeout);
      this.fetchBannerHideTimeout = null;
    }
    if (this.fetchBannerRemoveTimeout) {
      clearTimeout(this.fetchBannerRemoveTimeout);
      this.fetchBannerRemoveTimeout = null;
    }
    if (!this.fetchBannerEl) {
      return;
    }
    if (!immediate) {
      this.renderer.setStyle(this.fetchBannerEl, 'display', 'none');
      return;
    }
    if (this.fetchBannerEl.parentNode) {
      this.renderer.removeChild(document.body, this.fetchBannerEl);
    }
    this.fetchBannerEl = null;
    this.fetchBannerTitleEl = null;
    this.fetchBannerMessageEl = null;
  }
    
    //let i = 0;
   // for (const pub of publications_from_server) {
     // if (this.valueSelect == 'Seguidores') {
     //   if (pub['quienpuedever'] === 'Seguidores') {
     //    // i++;
     //     this.publications.push(pub);
    //    } 
   //   }else if(this.valueSelect == 'Para todos') {
   //       if (pub['quienpuedever'] === 'Para todos') {
   //         //i++;
   //         this.publications.push(pub);
   //       }
   //     }else{
          //i++;
   //         this.publications.push(pub);
   //     }
   //   }
    
    //  }else if(this.valueSelect == 'profile'){
        //if (pub['owner'] === true) {
      //    i++;
      //    this.publications.push(pub);
        //}
     // }else if(this.valueSelect == 'lkfilm') {
       // if (pub['publication_type'] == 'lkfilm'){
       //   i++;
      //    this.publications.push(pub);
     //   }
     
     
    //no hubo publicaciones de seguidores en la pagina X avanzar a la siguiente
   // console.log('number of publications with seguidores', i);
   // if (i==0 && this.actualizacionservice.current_page < 4 && this.valueSelect !== 'lkfilm'){
      
   //   await this.new_page();
   // }else if(i==0 && this.actualizacionservice.current_page >= 4 && this.valueSelect === 'lkfilm') {
    //  Swal2.fire({
  //      title: 'La velocidad del movimiento de tus dedos, excede el limite, no te desplazes tan rápido',
  //      icon: 'warning',
  //      confirmButtonText: 'Understood',
  //      color: '#ffffff',
  //      background: '#010f4e',
  //    });
  //    return;
   // }


  public Replace(value: unknown): string {
    const candidate = typeof value === 'string'
      ? value
      : (value as any)?.url || (value as any)?.route || (value as any)?.localUrl || '';

    return typeof candidate === 'string' ? candidate.split('?')[0] : '';
  }

  sharePublication(pub) {
    this.shareActionSheet(pub);
  }

  editPublication(pub) {

    let title = "";

    switch (pub.getType()) {
      case 'normal': {
        title = "Editar Publicación";
        break;
      }
      case 'event': {
        title = "Editar Evento";
        break;
      }
      default: {
        title = "Editar Publicación";
        break;
      }
    }

    this.publicationService.getPublicationByID(pub).then((publication) => {
      /*
      this.modalController.create({
        component: CreatePublicationComponent,
        canDismiss: true, // (forced globally for swipe close on all modals)
        componentProps: {
          title: title,
          publication: publication,
          publicationToShare: (publication)? publication : undefined,
          disablePost: true,
          isPost: false,
          idPublicationToEdit: this.publication['id']
        }
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      */
    }).catch((error) => {
      console.error(error);
    });

  }

  deletePublication(pub) {
    this.utils.loadingPresent().then(() => {
      this.publicationService.deletePublications(pub['id']).then((data) => {
        this.utils.loadingDismiss().then(() => {
          Swal2.fire({
            title: 'Publicación eliminada con Success',
            icon: 'success',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
          });
          //this.utils.alertPresent('Exito', 'Publicación eliminada', 'Se ha eliminado la publicación');
          //this.publicationDeleted.emit(true);

        });
      }).catch(error => {
        this.utils.loadingDismiss().then(() => {
          console.error(error);
          if (error.error) {
            error = JSON.parse(error.error);
            if (error.error == 'the publication no longer exist') {
              this.publicationService.DeleteLocalPublicationByID(pub.id);
            }
          }
        });
      });
    });
  }

  deleteAlertConfirm(pub) {

    this.inputAlertController.BinarySelectorAlert(
      'Eliminar publicación',				//Header
      '¿Estás seguro?',					//Message
      'Yes, delete',						//Ok Button
      'No, conservar'						//Cancel Button
    ).then((result) => {
      if (result['action']) {
        this.deletePublication(pub);
      }
    });
  }

  saveEditPublication(pub) {
    if (pub['is_saved']) {
      this.publicationService.deleteSavePublication(pub['id']).then((data) => {
        //console.error(data);
        pub['is_saved'] = false;
      }).catch((error) => {
        console.error(error);
        if (error.error) {
          error = JSON.parse(error.error);
          if (error.error == 'the publication no longer exist') {
            this.publicationService.DeleteLocalPublicationByID(pub.id);
          }
        }
      });
    } else {
      this.publicationService.postSavePublication(pub['id']).then((data) => {
        pub['is_saved'] = true;
        //console.error(data);
      }).catch((error) => {
        console.error(error);
        if (error.error) {
          error = JSON.parse(error.error);
          if (error.error == 'the publication no longer exist') {
            this.publicationService.DeleteLocalPublicationByID(pub.id);
          }
        }
      });
    }
  }

  shareActionSheet(pub) {
    let buttons = new Array<any>();
    buttons.push({text: 'Compartir', icon: 'share'});

    this.inputAlertController.SelectorActionSheet(buttons, "Selecciona la opción de compartir adecuada").then((result) => {
      if (result['action']) {
        switch (result['button']['text']) {
          case 'Compartir': {
            this.launchPublicationToShare(pub);
            break;
          }
          default:
            break;
        }
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  launchPublicationToShare(pub) {
    let title = "Compartir Publicación";

    this.publicationService.getPublicationByID(pub['id']).then((publicationToShare) => {
      let publication = new PublicationClass();
      publication.publication_type = "Publication";
      /*
      this.modalController.create({
        component: CreatePublicationComponent,
        canDismiss: true, // (forced globally for swipe close on all modals)
        componentProps: {
          title: title,
          publication: publication,
          publicationToShare: publicationToShare,
          disablePost: false,
          isPost: true,
          idPublicationToEdit: undefined
        }
      }).then((modal) => {
        modal.present();
      }).catch((error) => {
        console.error(error);
      });
      */
    }).catch((error) => {
      console.error(error);
    });
  }

  compra_confirmada(pub) {
    this.publicationService.getPublications(pub.id).then((data: any) => {

      pub = data;
    }).catch((error) => {
      console.error(error);
    });
  }

  async click_on_comments(pub) {
    if (!await this.registrationIntent.requireAccount('comment')) {
      return;
    }
    this.modalController.create({
      component: CommentsModalComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
      componentProps: {
        publication: pub,
        publicationId: pub['id'],
        CommentatorUsername: this.pr.username,
        user_id: pub.userProfile.user_id,
      }
    }).then((modal)=>{
      modal.present();
    });
  }
  click_on_reviews(pub) {
    this.modalController.create({
      component: CommentsModalComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
      componentProps: {
        publication: pub,
        publicationId: pub['id'],
        CommentatorUsername: this.pr.username,
        user_id: pub.userProfile.user_id,
        reviews: true,
        Valoraciones: pub.Valoraciones
      }
    }).then((modal)=>{
      modal.present();
    });
  }


  private parseReactionRequestError(error: any): any {
    if (!error) {
      return { error: 'unknown reaction request error' };
    }

    const responseBody = error.error;
    if (typeof responseBody === 'string') {
      try {
        return JSON.parse(responseBody);
      } catch {
        return { error: responseBody || error.message || 'reaction request failed' };
      }
    }

    if (responseBody && typeof responseBody === 'object') {
      return responseBody;
    }

    return {
      error: error.message || error.statusText || 'reaction request failed',
      status: error.status
    };
  }


  async click_on_like(pub) {
    if (!await this.registrationIntent.requireAccount('like')) {
      return;
    }
    const pendingKey = String(pub?.id || '');
    if (!pendingKey || this.reactionPending[pendingKey]) {
      return;
    }

    this.lightHaptic();
    this.reactionPending[pendingKey] = true;
    const audioFile = 'assets/sounds/send_sound.wav';
		const sound = new Howl({
		  src: [audioFile],
		  autoplay: true,
		  volume: 1.0, // Initial volume level (0.0 to 1.0)
		});
		sound.play();
    let reaction = { type: "Me gusta" };
    const previousReaction = pub.ownReaction;
    const previousCounter = Number(pub.reactionCounter || 0);

    if (( pub.ownReaction)? true: false) {
      pub['ownReaction'] = undefined;
      pub['reactionCounter'] = Math.max(0, previousCounter - 1);
      this.reactionService.deleteReaction(pub['id'], 'publications').then((data: any) => {
      }).catch((error) => {
        console.error(error);
        error = this.parseReactionRequestError(error);
        console.log('[PublicationReaction] delete failed', {
          publication_id: pub?.id,
          error
        });
        if(error.error == "You have no reaction in this publication"){
          pub['ownReaction'] = undefined;
          pub['reactionCounter'] = Math.max(0, previousCounter - 1);
        } else {
          pub['ownReaction'] = previousReaction;
          pub['reactionCounter'] = previousCounter;
        }
        if(error.error == 'the publication no longer exist'){
          this.publicationService.DeleteLocalPublicationByID(pub.id);
        }
      }).finally(() => {
        this.reactionPending[pendingKey] = false;
      });
    }
    else {
      pub.ownReaction = { reaction_name: 'Me gusta', optimistic: true };
      pub.reactionCounter = previousCounter + 1;
      this.reactionService.postReaction(reaction, pub['id'], "publications").then((data: any) => {
        if (Capacitor.getPlatform() !== 'web') {
        data = JSON.parse(data);
        }else{
          if (typeof data === 'string') {
            data = JSON.parse(data);
               console.log('json result publication service.ts', data);
               data = data; 
             }else {
              data= data; 
             }
        }


        let objectReaction = {
          ownReaction: {
            reaction_group_id: data.reaction_group_id,
            reaction_icon: null,
            reaction_id: data.reaction_id,
            reaction_name: data.reaction_apllied
          }
        };

        this.publicationService.getOwnReaction_Publications(objectReaction).then((ownReaction)=>{
          pub.ownReaction = ownReaction;
          this.sendNotificationLike(pub);
        });
       

      }).catch((error) => {
        console.log(error);
        error = this.parseReactionRequestError(error);
        console.log('[PublicationReaction] store failed', {
          publication_id: pub?.id,
          error
        });
        if(error.error == "you can only reaction once per publication"){
          this.publicationService.getPublicationByID(pub.id, true).then((publication)=>{
            pub.ownReaction = publication.ownReaction;
            pub.reactionCounter = publication.reactionCounter;
            pub.reactionContainer = publication.reactionContainer;
          }).catch((error)=>{
            console.error(error);
          });
        } else {
          pub.ownReaction = previousReaction;
          pub.reactionCounter = previousCounter;
        }
        if(error.error == 'the publication no longer exist'){
          this.publicationService.DeleteLocalPublicationByID(pub.id);
        }
      }).finally(() => {
        this.reactionPending[pendingKey] = false;
      });
    }
  }

  sendNotificationLike(pub): Promise<void> {
    return this.socialNotifications.notifySuccessfulInteraction({
      recipientProfileId: Number(pub?.userProfile?.user_id || 0),
      notifyRemote: !pub?.owner,
      remoteTitle: 'Nuevo me gusta en tu publicación',
      remoteBody: `@${this.pr.username} indicó que le gusta tu publicación.`,
      localTitle: 'Me gusta enviado',
      localBody: `Tu reacción a la publicación de @${pub?.userProfile?.username || 'Laniakea'} se guardó correctamente.`,
      extra: { publication_id: pub?.id, interaction_type: 'publication_like' },
    });
	}
  click_on_save(pub) {
    const audioFile = 'assets/sounds/send_sound.wav';
		const sound = new Howl({
		  src: [audioFile],
		  autoplay: true,
		  volume: 1.0, // Initial volume level (0.0 to 1.0)
		});
		sound.play();
    //delete the saved to the db
    if (pub.is_saved === true){
      this.request.createRequestPost('delete_save_publication',{id:pub.id}).then((result)=>{
        Swal2.fire({
          title: 'Publicación eliminada de marcadores',
          icon: 'success',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
        pub.is_saved = false;
      }).catch((error) => {

      });
    }else{
      this.request.createRequestPost('save_publication',{idPublication:pub.id}).then((result)=>{
		this.socialNotifications.notifyLocal(
		  'Publicación guardada',
		  'La publicación se agregó a tus marcadores.',
		  { event_type: 'publication_saved', publication_id: pub.id },
		);
        this.sendNotificationSaved(pub);
        this.AugmentSaveCounter(pub);
        pub.SaveCounter++;
        Swal2.fire({
          title: 'Publicación guardada con exito ',
          icon: 'success',
          confirmButtonText: 'Understood',
          color: '#ffffff',
          background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
        });
        pub.is_saved = true;
      }).catch((error) => {

      });
    }

  }
  sendNotificationSaved(pub) {
   
		return new Promise((resolve, reject) => {
		  const notification = {
			title: 'Han guardado tu publicación',
			body: `¡@${this.pr.username} ha guardado tu publicación!`,
			user_id: pub.userProfile.user_id,
	
		  };
	  
		  this.request.createRequestPost('GreatAtractorNotifications', notification)
			.then((data) => {
			
			  resolve(data);
			}).catch((error) => {
			  console.error('Failed to send notification:', error);
			  reject(error);
			});
		});
	  }
  Golkfilm(){
    this.modalController.create({
      component:LkfilmViewBySlidesComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)

    })

  }

  ionViewillEnter(pub) {
    this.faio.show({
      title: "Leyendo huella Digital",
      subtitle: "Use su huella para permitir el acceso a retiros",
    })
      .then((res) => {
        this.lanzamiento = setInterval(() => {
          this.mostrar = true
          console.log(`lanzamiento en ${this.numero}`);
          this.numero--
      
          if (this.numero === 0) {
            clearInterval(this.lanzamiento);
            console.log("Se terminó el tiempo con Exito!!");
      
            setTimeout(() => {
              this.mostrar = false;
              this.numero = 10;
            }, 4000);
            // Call envioRegalo() here
            this.openKYCApplicationModal(pub);
          }
        }, 1200);
        console.log(res);
        this.msg = 'Se valido el acceso con tu huella';
    
      })
      .catch((err) => {
        console.log(err);
        this.msg = 'Acceso incorrecto';
        alert(err);
      });
  }
  
  
  async RenewSuscription(pub): Promise<void> {
    if (!await this.registrationIntent.requireAccount('purchase')) {
      return;
    }
    Swal.fire({
      title: 'User subscription...',
      text: 'Your verified user subscription has expired. Please wait...',
      icon: 'success',
      timer: 4500, // Show the alert for 4.5 seconds
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
      });
    return new Promise<void>(async (resolve, reject) => {
      this.store.verbosity = this.store.DEBUG;
    
      // Register the product with the given ID
      this.store.register({
      id: this.productId2,
      alias: this.productId2,
      type: this.store.PAID_SUBSCRIPTION, // Change the type to PAID_SUBSCRIPTION
      });
    
      // Fetch the product information
      const product = await this.store.get(this.productId2);
    
      // Updated
      this.store.when(this.productId2).updated((product: IAPProduct) => {
     
        console.log('Updated' + JSON.stringify(product));
        });
    
      // User closed the native purchase dialog
      this.store.when(this.productId2).cancelled((product) => {
      console.error('Purchase was Cancelled');
      });
    
      // Run some code only when the store is ready to be used
      this.store.ready(() => {
      console.log('Store is ready');
      console.log('Products: ' + JSON.stringify(this.store.products));
      console.log(JSON.stringify(this.store.get(this.productId2)));
      });
    
      if (product) {
      // Check if the product is already owned
      if (product.state === this.store.OWNED) {
        //this.envioRegalo(pub);
        console.log('Product already owned');
        resolve();
        return;
      }
    
      // Check if the product is invalid
      if (product.state === this.store.INVALID) {
        reject(new Error('Product is invalid'));
        return;
      }
    
      // To make a purchase
      this.store.order(this.productId2);
    
      // Proceed with the purchase flow
      this.store.when(this.productId2).approved((product) => {
        product.finish();
    
        console.log('Subscription ordered!');
    
        this.store.when(this.productId2).owned(async (product) => {
          //this.envioRegalo(pub);
        console.log('Product is owned');
        this.sendNotification('Estatus de tu perfil actualizado', '¡Felicitaciones! Ya tienes acceso a la cartera Hubble.');
        
        });
      });
    
      // Handle error events
      this.store.when(this.productId2).error((err) => {
        console.log('Error occurred during purchase:', err);
        reject(err);
      });
    
      // Refresh the product information
      this.store.refresh();
      } else {
      reject(new Error('Failed to fetch product information'));
      }
    
    });
    }
    
    sendNotification(title, body) {
     
    return new Promise((resolve, reject) => {
      const notification = {
      title: title,
      body: body,
      user_id:this.pr.id,
  
      };
    
      this.request.createRequestPost('GreatAtractorNotifications', notification)
      .then((data) => {
       
        resolve(data);
      }).catch((error) => {
        console.error('Failed to send notification:', error);
        reject(error);
      });
    });
    }


    async presentActionSheet(pub){
      await this.setNativePublicationInformationVisible(false);
      Swal.fire({
        title: '',
        text: '',
        icon: 'success',
        timer: 9999, // Show the alert for 45 seconds
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false
        });
      setTimeout(() => {
        this.ActionSheetController.dismiss();
        }, 9999); 
      const actionSheet = await this.ActionSheetController.create({
        header: 'Acerca de la publicación',
        cssClass: 'title-action',
        buttons: [
        
          {
          text: 'Eliminar publicación',
          icon: 'trash-outline',
          cssClass: 'icon',
          handler: () => {
            if(pub.owner){
              const audioFile = 'assets/sounds/send_sound.wav';
              const sound = new Howl({
                src: [audioFile],
                autoplay: true,
                volume: 1.0, // Initial volume level (0.0 to 1.0)
              });
              sound.play();
              this.deleteAlertConfirm(pub);
            }  else{
              Swal2.fire({
                title: 'Al parecer no es tu publicación',
                text: `Solo puedes eliminar tus publicaciones`,
                icon: 'error',
                confirmButtonText: 'Understood',
                color: '#ffffff',
                background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
                }).then(() => {
                console.log("Alert displayed successfully.");
                }).catch(error => {
                console.error("Error displaying alert:", error);
                });
            }
          }
        },
        {
          text: 'Reportar publicación',
          icon: 'flag-sharp',
          cssClass: 'icon',
          handler: () => {
   

            this.presentReportActionSheet(pub);
          }
        },
        {
          text: 'Copiar enlace de publicación',
          icon: 'link-outline',
          cssClass: 'icon',
          handler: () => {
          
this.click_on_share(pub);
this.AugmentSharesCounter(pub);
const audioFile = 'assets/sounds/send_sound.wav';
const sound = new Howl({
  src: [audioFile],
  autoplay: true,
  volume: 1.0, // Initial volume level (0.0 to 1.0)
});
sound.play();

          }
        }, {
          text: 'Compartir con otras aplicaciones',
          icon: 'analytics-outline',
          cssClass: 'icon',
          handler: () => {
           if (Capacitor.getPlatform() !== 'web') {   
            this.Share(pub);
           
            this.AugmentSharesCounter(pub);
            const audioFile = 'assets/sounds/send_sound.wav';
            const sound = new Howl({
              src: [audioFile],
              autoplay: true,
              volume: 1.0, // Initial volume level (0.0 to 1.0)
            });
            sound.play();
           }else{
            Swal2.fire({
              title: 'Funcionalidad no disponible en el navegador',
              text: `Access this feature in the Play Store or App Store app`,
              icon: 'info',
              confirmButtonText: 'Understood',
              color: '#ffffff',
              background: '#010f4e',
              position: 'top-end',
              timerProgressBar: true,
              toast: true,
              }).then(() => {
              console.log("Alert displayed successfully.");
              }).catch(error => {
              console.error("Error displaying alert:", error);
              });
          }
          }
        }, 
        
        {
          text: 'Proliferar',
          icon: 'git-compare-outline',
          cssClass: 'icon',
          handler: () => {
   this.ProliferarPublicacion(pub);
   console.log(pub.id);
   const audioFile = 'assets/sounds/send_sound.wav';
   const sound = new Howl({
     src: [audioFile],
     autoplay: true,
     volume: 1.0, // Initial volume level (0.0 to 1.0)
   });
   sound.play();
          }
        },
        {
          text: 'Añadir a lista de reproducción.',
          icon: 'library',
          cssClass: 'icon',
          handler: () => {
      
              const audioFile = 'assets/sounds/send_sound.wav';
              const sound = new Howl({
                src: [audioFile],
                autoplay: true,
                volume: 1.0, // Initial volume level (0.0 to 1.0)
              });
              sound.play();
             
           this.open_playlists_popover(pub);
          }
        },
       
      ]
      });
      await actionSheet.present();
  
      const { role } = await actionSheet.onDidDismiss();
      await this.setNativePublicationInformationVisible(true);
      console.log('onDidDismiss resolved with role', role);
    
    }
    async open_playlists_popover(pub){
      const popover = await this.popoverCtrl.create({
        component: PlaylistsComponent, // Replace with your component for observations
        translucent: true,
      //  event: ev,
        componentProps: {
          añadir_a_lista:true,
          pub:pub
  
        },
        backdropDismiss: true, // Allow dismissal by tapping outside the popover
      });
    
      await popover.present();
    }
    ProliferarPublicacion(pub){
      return new Promise((resolve, reject) => {
     
      
        this.request.createRequestPost('ProliferarPublicacion', {id: pub.id})
        .then((data) => {
          Swal2.fire({
            title: 'Publicación actualizada con Success',
            text: `La publicación ha sido actualizada con Success, y se han modificado tus publicaciones proliferadas `,
            icon: 'success',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            }).then(() => {
            console.log("Alert displayed successfully.");
            }).catch(error => {
            console.error("Error displaying alert:", error);
            });
          resolve(data);
        }).catch((error) => {
          Swal2.fire({
            title: 'Hubo un error al proliferar',
            text: `Hubo un error al proliferar la publicación, si el error persiste, favor de counicarse al soporte de Laniakea`,
            icon: 'error',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
            }).then(() => {
            console.log("Alert displayed successfully.");
            }).catch(error => {
            console.error("Error displaying alert:", error);
            });
          console.error('Failed to send notification:', error);
          reject(error);
        });
      });

    }
    async Share(pub){

      const publicationId = pub.id;
      const url = this.sharePreviewService.publication(publicationId);
      await Share.share({
        url: url,
      });
    }

    AugmentSharesCounter(pub){
      return new Promise((resolve, reject) => {
     
      
        this.request.createRequestPost('AugmentShareCounter', {id: pub.id})
        .then((data) => {
          pub.SharedCounter++;
          resolve(data);
        }).catch((error) => {
          console.error('Failed to send notification:', error);
          reject(error);
        });
      });

    }

    AugmentSaveCounter(pub){
      return new Promise((resolve, reject) => {
     
      
        this.request.createRequestPost('AugmentSaveCounter', {id: pub.id})
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          console.error('Failed to send notification:', error);
          reject(error);
        });
      });

    }
    async fetchProfilePublications(isrefresh: boolean){
      const result = await this.actualizacionservice.getProfilePublications(null, isrefresh, this.profile_id, false, null) ;
      const fetchedPublications = result || [];
  
      
      this.filterPublications(fetchedPublications);
      
    }
    async filterPublications(publications) {
    console.log('filering');
      if (publications.length > 0) {
        this.publications = publications;
      
      }
    
      console.log('siguiendo length of pub', this.publications.length);
    
    
    }
    formatCounter(value: number): string {
      if (value >= 1000000000000) {
        return (value / 1000000000000).toFixed(1) + 'T';
      } else if (value >= 1000000000) {
        return (value / 1000000000).toFixed(1) + 'B';
      } else if (value >= 1000000) {
        return (value / 1000000).toFixed(1) + 'M';
      } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'K';
      } else {
        return value.toString();
      }
    }
    async presentReportActionSheet(pub){
      Swal.fire({
        title: '',
        text: '',
        icon: 'success',
        timer: 9999, // Show the alert for 45 seconds
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false
        });
      setTimeout(() => {
        this.ActionSheetController.dismiss();
        }, 9999); 
      const actionSheet = await this.ActionSheetController.create({
        header: '¿Porqué estás reportando la publicación? Tu reporte es público, solo los usuarios verificados y que han comprado esta publicación, pueden realizar algún reporte.',
        cssClass: 'title-action',
        buttons: [
        
          {
          text: 'Simplemente no me gusta.',
          icon: 'heart-dislike-circle',
          cssClass: 'icon',
          handler: () => {
            const description = `Simplemente no me gusta.

            Esta opción se utiliza cuando simplemente no te gusta y te desagrada la publicación o el contenido, pero no infringe directamente o específicamente ninguna de las políticas de uso de la plataforma. Tu opinión es importante, pero recuerda que el reporte debe ser coherente con las políticas de la comunidad y no se tomarán medidas si no se ha producido una infracción clara de las reglas.
        
            Por favor, utiliza esta opción de manera responsable y reporta solo cuando sea necesario.`;
        
         this.presentReportSelectedActionSheet(pub, description, 'Simplemente no me gusta.');


          }
        },
        {
          text: 'Comportamiento engañoso y spam.',
          icon: 'megaphone',
          cssClass: 'icon',
          handler: () => {
   

            const description= `Comportamiento engañoso y spam.
            
            Queda prohibido lo siguiente:

            A) Interacción falsa.

            1. Ofrecimiento de instrucciones o promoción de métodos o servicios para ayudar a un usuario a aumentar artificialmente la interacción, como la venta de seguidores o me gusta.

            B) Spam.

            1. Cuentas que se operan de forma masiva o mediante automatización no autorizada, como bots, para distribuir altos volúmenes de contenido, entre otras cosas, con fines comerciales.

            2. Redes de cuentas que representan entidades similares o publican contenido similar para llevar a los usuarios a ubicaciones específicas dentro o fuera de la plataforma, como otras cuentas, sitios web y negocios.
            `;
            this.presentReportSelectedActionSheet(pub, description, 'Comportamiento engañoso y spam.');
           
          }
        },
        {
          text: 'Desnudez o actividad sexual.',
          icon: 'close-circle',
          cssClass: 'icon',
          handler: () => {
            const description= `Desnudez o actividad sexual.
            
            Queda prohibido lo siguiente:

            A) Actividad, provocación y explotación sexual de jóvenes.

            1. Demostración o divulgación de materiales de abuso sexual infantil o actividad sexual juvenil.

            2. Demostración o incitación de desnudez juvenil.

            3. Promoción o normalización de la explotación sexual, el abuso sexual y el fetichismo sexual de jóvenes, incluidos el grooming, la sextorsión y la pedofilia.

            4. Demostración o promoción de la provocación sexual, incluida la invitación de menores de 18 años a participar en un acto sexual, o a salir de la plataforma y compartir imágenes sexualmente explícitas, incluso si el inciciador también es menor de 18 years.

            5. Cosificación o sexualización de  menores de 18 años a través de imágenes o funciones de interacción en la aplicación.

            B) Comportamiento sexualmente provocativo por parte de jóvenes.

            1. Exposición excesiva del cuerpo por parte de los jóvenes.

            2. Actuaciones provocativas de menores de 18 years.

            3. Referencias e insinuaciones directas o indirectas al sexo o las actividades sexuales por parte de los jóvenes.

            C) Actividad, servicios o provocación sexuales de personas adultas.

            1. Ofrecimiento o solicitación de parejas sexuales o participación en un acto sexual.

            2. Contenido sexualmente explícito, incluido contenido pornográfico que muestre relaciones sexuales, la masturbación y descripciones vívidas de actos sexuales.

            E) Personas adultas desnudas.

            1. Imágenes de personas adultas desnudas, incluidas las fotografías y las imágenes creadas digitalmente (como manga y anime).

            F) Lenguaje sexualmente explícito.

            1. Relatos sexualmente explícitos, como descripciones vívidas de actos sexuales realizados por adultos o menores de 18 years.
            `;
            this.presentReportSelectedActionSheet(pub, description, 'Desnudez o actividad sexual.');

          }
        }, {
          text: 'Discurso o símbolos de odio.',
          icon: 'thumbs-down',
          cssClass: 'icon',
          handler: () => {
            const description= `Discurso o símbolos de odio.
            
            Queda prohibido lo siguiente:
            
            1. Demostración o promoción de la violencia, la discriminación u otro tipo de daño, incluida la reivindicación de la supremacía sobre la base de características personales, como la raza, la religión, el género o la orientación sexual.
            
            2. Denigración de una persona basándose en estas características personales, incluido el uso de insultos de odio.
            
            3. Negación de eventos históricos bien documentados que causaron daño a grupos protegidos, como el Holocausto.
            
            4. Promoción o apoyo de entidades individuos u organizaciones que fomentan ideologías de odio.`;
            this.presentReportSelectedActionSheet(pub, description, 'Discurso o símbolos de odio.');
          }
        }, 
        
        {
          text: 'Intimidación o acoso.',
          icon: 'sad',
          cssClass: 'thumbs-down',
          handler: () => {
            const description= `Intimidación o acoso.

            Queda prohibido lo siguiente:
            
            1. Demostración o promoción del uso de insultos hacia otras personas o amenazas de insultar a alguien, incluido el uso de palabras malsonantes o lenguaje obsceno para denigrar a la gente.

            2. Demostración, incitación o amenazas de recurrir al acoso o la intimidación, física o de otro tipo, de otras personas, incluido el acoso coordinado.
            
            3. Demostración, promoción o amenazas de comportamiento como doxing, chantaje, revelación de información privada o confidencial o solicitudes de revelarla.`;
            this.presentReportSelectedActionSheet(pub, description, 'Intimidación o acoso.');

          }
        },
        {
          text: 'Información falsa.',
          icon: 'newspaper',
          cssClass: 'icon',
          handler: () => {
            const description= `Información falsa.
            
            Queda prohibido lo siguiente:
            
            A) Información errónea sobre elecciones.
            
            1. Desinformación sobre el procedimiento para votar o la postulación para un cargo.
            
            2. Desinformación sobre los resultados finales de elecciones.
            
            B) Desinformación prejudicial.
            
            1. Desinformación que representa un riesgo para la seguridad pública o que puede causar pánico, como el uso de imágenes de un evento pasado para presentar falsamente un aconcetimiento actual, o la difusión de afirmaaciones inexactas de la falta de disponibilidad de bienes de primera necesidad como alimentos o agua.
            
            2. Información médica falsa que representa un riesgo para la salud pública, como declaraciones engañosas sobre vacunas o consejos médicos incorrectos que desalientan a las personas a obtener la atención médica adecuada.
            
            3. Desinformación sobre el cambio climático que contradice un consenso científico bien establecido, como la negación de la existencia del cmabio climático.
            
            4. Teorías de conspiración peligrosas que promueven la violencia, el odio o atacan a personas, como las que crean prejuicios sobre un grupo específico y causan daño.
            
            C) Deepfakes, imágenes sintéticas o manipuladas.
            
            1. Imágenes sintéticas o manipuladas que muestran escenas realistas y que no se divulgan o etiquetan como tales en el video.
            
            2. Imágenes sintéticas que guardan un parecido (visual o sonoro) con una persona real cuando se usan para patrocinios políticos o comerciales o que infringen las normas de la comunidad.
            
            3. Material que se ha editado se una manera que pueda inducir a error a una persona sobre eventos del mundo real.`;
            this.presentReportSelectedActionSheet(pub, description, 'Información falsa.');

          }
        },
        {
          text: 'Violiencia, abuso o explotación criminal.',
          icon: 'nuclear',
          cssClass: 'icon',
          handler: () => {
            const description = `Violiencia, abuso o explotación criminal.
            
            Queda prohibido lo siguiente:

            A) Explotación y abuso de menores de 18 years.

            1. Demostración o incitación de la explotación sexual de personas menores de 18 años, incluido el uso de material de abuso sexual infantil, grooming, provocación y pedofilia.
            
            2. Demostración o incitación de abuso físico, abandono y maltrato psicológico de personas menores de 18 years.
            
            3. Demostración o promoción de la trata de personas menores de 18 años y el reclutamiento de soldados menores de edad.
            
            4. Promoción o facilitación del matrimonio entre menores.
            
            B) Violencia física y amenazas violentas: 
            
             1. Demostración, promoción o amenazas con violencia física, incluida la tortura en el mundo real, violencia explícita y lucha física extrema.

             2. Promoción y apoyo material a organizaciones violentas o que promueven el odio, incluidos los extremistas violentos y las organizaciones criminales.
             
            C) Explotación y abuso sexual.
            
            1. Demostración o promoción de actos sexuales no consentidos, sean reales o ficticios, incluidos el acoso y la violación.
            
            2. Demostración o promoción de la divulgación no consentida de contenido íntimo o amenazas para compartir dicho contenido.
            
            3. Edicción de contenido con el fin de sexualizar a alguien o crear la apariencia de que una persona está involucrada en actividad sexual.
            
            4.. Declaraciones no deseadas o humillantes, como declaraciones sobre las partes privadas del cuerpo, la actividad sexual o la vida sexual privada de alguien.
            
            D) Maltrato animal.
            
            1. Demostración o incitación de abuso físico, maltrato o descuido de los animales.
            
            2. Demostración o incitación de actividades sexuales entre un animal y un ser humano (zoofilia).
            
            E) Otras actividades delictivas. Demostración, promoción u ofrecimiento de instrucciones sobre como cometer robos o destruir propiedades, u otras actividades delictivas que podrían hacer daño a personas, animales o el medio ambiente.`;
            
            this.presentReportSelectedActionSheet(pub, description, 'Violiencia, abuso o explotación criminal.');

          }
        },
        {
          text: 'Estafa o fraude.',
          icon: 'warning',
          cssClass: 'icon',
          handler: () => {
            const description= `Estafa o fraude.
            
            Queda prohibido lo siguiente:
            
            1. Estafas financieras, de inversión, laborales o phishing, incluido el robo de identidades.

            2. Coordinación o facilitación de estafas, o instrucciones sobre como realizar estafas.
            
            3. Fraude organizacional, como lavado de dinero o movimiento de dinero obtenido de forma ilegal para otra persona ('Money muling').
            
            4. Reclutamiento para marketing multinivel
            
            5. Esquemas piramidales o ponzi.`;
            this.presentReportSelectedActionSheet(pub, description, 'Estafa o fraude.');

          }
        },
        {
          text: 'Falsificaciones y propiedad intelectual.',
          icon: 'document-text',
          cssClass: 'icon',
          handler: () => {
            const description= `Falsificaciones y propiedad intelectual.
            
            Queda prohibido lo siguiente:
            
            A) Productos falsificados.
            
            1. Promoción del comercio de productos falsificados, como artículos de lujo.`;
            this.presentReportSelectedActionSheet(pub, description, 'Falsificaciones y propiedad intelectual.');

          }
        },
        {
          text: 'Suicidio o autolesión.',
          icon: 'skull',
          cssClass: 'icon',
          handler: () => {
            const description= `Suicidio o autolesión.

            Queda prohibido lo siguiente:

            1. Demostración, promoción u ofrecimiento de instrucciones sobre el suicidio, la autolesión y juegos, desafíos, retos, bromas y pactos relacionados.

            2. Divulgación de planes de suicidio o autolesión.`;
            this.presentReportSelectedActionSheet(pub, description, 'Suicidio o autolesión.');

          }
        },
        {
          text: 'Desorden alimenticio e imagen corporal poco saludable.',
          icon: 'beer',
          cssClass: 'icon',
          handler: () => {
            const description= `Desorden alimenticio e imagen corporal poco saludable.
            
            Queda prohibido lo siguiente:
            
            1. Demostración o fomento de trastornos alimentarios, como dietas extremas, ayuno, atracones o vómitos intencionales, así como otros comportamientos peligrosos para perder peso, incluido el ejercicio compulsivo y el uso de medicamentos y suplementos potencialmente dañinos.
            
            2. Demostración o promoción de tendencias inapropiadas relacionadas con la toma de medidas corporales.`;
            this.presentReportSelectedActionSheet(pub, description, 'Desorden alimenticio e imagen corporal poco saludable.');

          }
        },
        {
          text: 'Contenido impactante o explícito.',
          icon: 'videocam-off-outline',
          cssClass: 'icon',
          handler: () => {
            const description= `
            Contenido impactante o explícito.
            
            Queda prohibido lo siguiente:

            1. Muertes y accidentes violentos.

            2. Partes del cuerpo humano o animal desmembradas, mutiladas, carbonizadas, quemadas o gravemente heridas.
            `;
            this.presentReportSelectedActionSheet(pub, description, 'Contenido impactante o explícito.');

          }
        },
        {
          text: 'Actividades y mercancias reguladas.',
          icon: 'ribbon-outline',
          cssClass: 'icon',
          handler: () => {
            const description= `
            Actividades y mercancias reguladas.
            
            Queda prohibido lo siguiente:

            A) Juegos de azar.

            1. Servicios de juegos de azar, como casinos, póquer, juegos de tragamonedas, ruleta, lotería, consejos sobre apuestas y software y aplicaciones relacionadas con juegos de azar.

            B) Alocohol, tabaco y drogas.

            1. Demostración de jóvenes que poseen, consumen o intercambian bebidas alcohólicas, productos de tabaco, drogas u otras sustancias reguladas.

            2. Demostración o incitación al consumo de drogas u otras sustancias reguladas con fines recreativos por parte de personas adultas.

            3. Demostración o promoción del uso indebido de artículos de domésticos comúnes o productos de venta libre para intoxicarse, como antihistamínicos, o la inhalación de pegamento.

            4. Ofrecimiento de isntrucciones sobre cómo fabricar bebidad alcohólicas, drogas u otras sustancias reguladas caseras.

            5. Fomento del comercio o la compra de alcohol, productos de tabaco, drogas u otras sustancias reguladas.

            C) Armas de fuego y otras armas peligrosas.

            1. Demostración o promoción de armas de fuego o explosivos que no se usan en un entorno seguro o apropiado.

            2. Fomento del comercio u ofrecimiento de instrucciones sobre como fabricar armas de fuego o explosivos.

            D) Comercio de otros bienes o servicios regulados.

            1. Comercio de dinero y documentos falsos e información robada.

            2. Comercio de animales salvajes y partes del cuerpo de animales en peligro de extinción, como productos y medicamentos elaborados con marfil.
            `;
            this.presentReportSelectedActionSheet(pub, description, 'Actividades y mercancias reguladas.');

          }
        },
        {
          text: 'Divulgación de datos personales.',
          icon: 'id-card-outline',
          cssClass: 'icon',
          handler: () => {
            const description= `Divulgación de datos personales.
            
            Queda prohibido lo siguiente:
            
            1. Divulgación de números de teléfonos personales y domicilios particulares.
            
            2. Divulgación de información financiera y de pago, como cuentas bancarias y números de tarjetas de débito o crédito.
            
            3. Divulgación de datos de acceso, como nombres de usuario y contraseñas.
            
            4. Divulgación de documentos o números de identidad, como pasaportes y números de seguridad social.`;
            this.presentReportSelectedActionSheet(pub, description, 'Divulgación de datos personales.');

          }
        },
        {
          text: 'Actividades y retos peligrosos.',
          icon: 'alert-circle-outline',
          cssClass: 'icon',
          handler: () => {
            const description= `Actividades y retos peligrosos.
            
            Queda prohibido lo siguiente:

            1. Demostración o promoción de actividades, juegos, desafíos, maniobras o retos peligrosos que causan o podrían causar daños físicos importantes o daños a la propiedad, como el uso inadecuado de herramientas peligrosas, el consumo de sustancias peligrosas o un estilo de conducción peligroso.
            `;
            this.presentReportSelectedActionSheet(pub, description, 'Actividades y retos peligrosos.');

          }
        },
        {
          text: 'Otro.',
          icon: 'arrow-forward-circle-outline',
          cssClass: 'icon',
          handler: () => {
            const description= `Nuestra prioridad es ofrecer un entorno seguro y solidario. También fomentamos interacciones auténticas manteniendo el contenido y las cuentas engañosas al margen de nuestra plataforma. Selecciona esta opcion no se encuntra entre las categorías enumeradas.`;
            this.presentReportSelectedActionSheet(pub, description, 'Otro.');

          }
        },
        

      ]
      });
      await actionSheet.present();
  
      const { role } = await actionSheet.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    
    }

    async presentReportSelectedActionSheet(pub, description, title) {
      Swal2.fire({
        title: `Reportar`,
        text: `${description}`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancel',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // Your logic here
          this.postReview(pub, title);
        }
      });
    }
    public postReview(pub, title) {
      title= 'Reporte de: ' +title;
     
      this.newComment = new CommentClass(pub.id);
      this.newComment.setText(title);
      let temporalComment =  this.newComment;
      this.newComment = new CommentClass(temporalComment.publication_id);
      this.utils.loadingPresent().then(() => {
        this.commentService.postReview(temporalComment.getDataToSend(), pub.id).then((data: any) => {
          this.publicationService.DeleteLocalPublicationByID(pub.id);
          if (Capacitor.getPlatform() !== 'web') {
          data = JSON.parse(data);
          }
          Swal2.fire({
            title: 'El reporte fue enviado exitosamente',
            text: 'La denuncia se ha sido publicado exitosamente. ',
            icon: 'success',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
            });
          //console.log(data);
          let commentId = data.comment_id;
          console.log('blobs multimedia', this.commentService.blobsMultimediaComment);

            this.utils.loadingDismiss().finally(() => {
          
                this.commentService.updateReviewList(data.comment, pub);
              
              
              this.commentService.blobsMultimediaComment = [];
              this.newComment.deleteMultimedia(0);
            });
      
          
        }).catch((error) => {
          
          Swal2.fire({
            title: 'El reporte no fue enviado exitosamente',
            text: 'Asegúrate de ser un usario verificado y haber comprado el producto o sevicio de la publicación. If the error persists, contact Laniakea support',
            icon: 'error',
            confirmButtonText: 'Understood',
            color: '#ffffff',
            background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
            });
          console.error(error);
          
          this.utils.loadingDismiss();
          if(error.error){
            error = JSON.parse(error.error);
            if (error.error == 'the publication no longer exist') {
           
              this.publicationService.DeleteLocalPublicationByID(pub.id);
            }
          }
        }).finally(() => {
          //this.newComment = new CommentClass(this.publicationId);
        });
      });
  
    }
}
